import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    home: 'HOME',
    videoProduction: 'VIDEO PRODUCTION',
    postProduction: 'POST PRODUCTION',
    onAirIdentity: 'ON-AIR IDENTITY',
    marketingBranding: 'MARKETING & BRANDING',
    webServices: 'WEB SERVICES',
    contact: 'CONTACT',
    search: 'Search...',
    // Footer
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
    disclaimer: 'Disclaimer',
    allRightsReserved: 'All rights reserved',
    // Common
    getStarted: 'Get Started',
    learnMore: 'Learn More',
    sendMessage: 'Send Message',
    bookConsultation: 'Book Consultation',
    subscribe: 'Subscribe',
    sitemap: 'Sitemap',
    legal: 'Legal',
    mostPopular: 'MOST POPULAR',
    delivery: 'Delivery',
    days: 'days',
    additionalOptions: 'Additional Options',
    webCtaTitle: 'Start building your website smarter today',
    webCtaButton: 'Book Consultation',
    // Extra Options
    extraVideoHeader: 'Video Header / Animated Header',
    extraVideoHeaderPrice: 'USD 50',
    extraSEO: 'Search Engine Optimization',
    extraSEOPrice: 'USD 50',
    extraWhatsApp: 'WhatsApp Chat',
    extraWhatsAppPrice: 'USD 50',
    extraChatBot: 'Customer Service Chat Bot (AI)',
    extraChatBotPrice: 'USD 500',
    extraTVCommercial: 'Budget TV Commercial',
    extraTVCommercialPrice: 'USD 250 - 30s | USD 450 - 60s',
    extraLanguage: 'Extra Language',
    extraLanguagePrice: 'USD 50 per language',
    extraDomain: 'Domain Name Registration',
    extraDomainPrice: 'Price upon request',
    extraEcommerce: 'E-commerce Solutions',
    extraEcommercePrice: 'Price upon request',
    extraTestimonials: 'Video Testimonials (3 people)',
    extraTestimonialsPrice: 'USD 100',
    extraPhotography: 'On-Location Photography',
    extraPhotographyPrice: 'USD 150',
    extraSearch: 'Search Function',
    extraSearchPrice: 'USD 50',
    extraAnalytics: 'Google Analytics',
    extraAnalyticsPrice: 'USD 25',
    extraAIGeneration: 'AI Image and Video Generation',
    extraAIGenerationPrice: 'USD 50',
    // Portfolio Grid
    portfolioProductionSetup: 'Production Setup',
    portfolioProfessionalLighting: 'Professional Lighting',
    portfolioCinematographer: 'Cinematographer',
    portfolioCameraSetup: 'Camera Setup',
    portfolioPostProduction: 'Post-Production',
    portfolioFX6Camera: 'FX6 Cinema Camera',
    // Hero Slider
    heroSlide1Name: 'TBL Cinemas',
    heroSlide1Desc: 'Brand identity promo with slogan and short versions for social media',
    heroSlide2Name: 'Datasignz CreativeMinds Showreel',
    heroSlide2Desc: '',
    heroSlide3Name: 'Akira Overwater Resort',
    heroSlide3Desc: 'Promo video',
    heroSlide4Name: 'Birdland Suriname',
    heroSlide4Desc: 'Cock of the Rock',
    heroSlide5Name: 'BBC documentary',
    heroSlide5Desc: 'How the Amazon became a safe-haven for enslaved Africans',
    // Contact Page
    contactUs: 'Contact Us',
    getInTouch: 'Get in Touch',
    sendUsMessage: 'Send us a Message',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    subject: 'Subject',
    message: 'Message',
    service: 'Service',
    preferredDate: 'Preferred Date',
    additionalNotes: 'Additional Notes',
    pickDate: 'Pick a date',
    sending: 'Sending...',
    booking: 'Booking...',
    contactSubtitle: "Ready to bring your vision to life? We'd love to hear from you.",
    bookConsultationTitle: 'Book a Consultation',
    contactInfo: 'Contact Information',
    subscribeNewsletter: 'Subscribe to Our Newsletter',
    newsletterDesc: 'Stay updated with our latest projects and offers.',
    visitUs: 'Visit Us',
    // Services
    selectService: 'Select a service',
    videoService: 'Video Production',
    postService: 'Post Production',
    marketingService: 'Marketing & Branding',
    webService: 'Web Services',
    // Home Page
    welcomeTitle: 'Welcome to Datasignz CreativeMinds',
    welcomeSubtitle: 'Your Partner in Creative Excellence',
    ourWork: 'Our Work',
    ourServices: 'Our Services',
    viewPortfolio: 'View Portfolio',
    // Web Services Page
    webServicesTitle: 'Web Services by NeuralNext',
    webServicesDesc1: 'NeuralNext is a forward-thinking digital solutions division within Datasignz CreativeMinds focused on building intelligent websites and applications that adapt, learn, and perform. As a specialized division of Datasignz CreativeMinds, NeuralNext blends advanced automation, data-driven logic, and human-centered design to deliver platforms that work smarter and scale faster.',
    webServicesDesc2: "We don't just develop digital products — we engineer responsive ecosystems that anticipate user behavior, streamline operations, and unlock measurable growth. From concept to deployment, NeuralNext transforms complexity into seamless digital experiences built for the future.",
    webServicesDesc3: 'A core component of this approach is the strategic deployment of conversational interfaces. Intelligent chatbots extend your digital presence beyond static interaction by providing real-time engagement, automated customer support, and guided user journeys at scale.',
    webServicesDesc4: 'By handling routine inquiries, qualifying leads, and integrating directly with internal systems, chatbots reduce operational friction, improve response times, and generate actionable insights. The result is increased efficiency, higher conversion rates, and a consistently accessible customer experience, without adding overhead.',
    webServicesCTA: 'Try it yourself. Click the black and white icon in the bottom right corner.',
    ourPortfolio: 'Our Portfolio',
    // Web Services Packages
    landingPage: 'Landing Page',
    websiteBudget: 'Website Budget',
    websiteStandard: 'Website Standard',
    websiteElite: 'Website Elite',
    // Web Services Features
    basicDesign: 'Basic design',
    responsiveLayout: 'Responsive layout',
    contactForm: 'Contact form',
    socialMediaIntegration: 'Social media integration',
    photoGallery: 'Photo gallery',
    fourPages: '4 pages',
    bookingsForm: 'Bookings form',
    customDesign: 'Custom design matching branding',
    maxTenPages: 'Maximum 10 pages',
    photoGalleryVideo: 'Photo gallery & video links',
    bookingQuoteForm: 'Booking/Quote form',
    maxTwentyFivePages: 'Maximum 25 pages',
    // Web Services Extras
    videoHeader: 'Video Header / Animated Header',
    seoTitle: 'Search Engine Optimization',
    searchFunction: 'Search Function',
    whatsappChat: 'WhatsApp Chat Integration',
    googleAnalytics: 'Google Analytics',
    aiImageVideo: 'AI Image and Video Generation',
    ecommerceSolutions: 'E-commerce Solutions',
    domainHosting: 'Domain Registration & Hosting',
    priceOnRequest: 'Price upon request',
    // Web Services Process
    webDevProcess: 'Our Web Development Process',
    planning: 'Planning',
    planningDesc: 'Define goals & requirements',
    designStep: 'Design',
    designStepDesc: 'UI/UX & visual identity',
    development: 'Development',
    developmentDesc: 'Building your website',
    testing: 'Testing',
    testingDesc: 'Quality assurance',
    launch: 'Launch',
    launchDesc: 'Go live & support',
    // CTA Section
    ctaTitle: 'Ready to bring your vision to life?',
    ctaSubtitle: "Let's discuss your project and create something extraordinary together.",
    getQuote: 'Get a Quote',
    // Video Production Page
    videoProductionTitle: 'Video Production',
    videoProductionDesc1: 'Datasignz Creative Minds brings stories to life through purposeful, high-impact video production. We create visual content that does more than look good — it communicates, persuades, and performs. From brand films and commercials to corporate videos and digital content, every production is strategically designed to strengthen your message and elevate your brand.',
    videoProductionDesc2: 'With a sharp creative vision and a results-driven approach, we combine storytelling, cinematography, and post-production expertise to deliver videos that connect with your audience and support your business objectives. Whether you are launching a brand, promoting a service, or building long-term visibility, Datasignz Creative Minds turns ideas into compelling visual experiences.',
    featuredClients: 'Featured clients:',
    // Video Production Services
    tvCommercialsTitle: 'TV Commercials & Advertising',
    tvCommercialsDesc: 'Professional commercials for retail, automotive, hospitality, and corporate clients.',
    corporateFilmsTitle: 'Corporate Films & Mood Videos',
    corporateFilmsDesc: 'Identity-driven productions that highlight company culture, values, and brand promise.',
    musicVideosTitle: 'Music Videos',
    musicVideosDesc: 'Creative collaborations with artists to bring their vision to life.',
    documentariesTitle: 'Documentaries & Short Films',
    documentariesDesc: 'Covering cultural, environmental, and social themes with cinematic quality.',
    promoVideosTitle: 'Promo Videos',
    promoVideosDesc: 'Promotional films for brands, projects, and events.',
    afterMoviesTitle: 'After Movies / Event Videos',
    afterMoviesDesc: 'Recap videos of events that capture the energy and highlights.',
    readyBringVision: 'Ready to bring your vision to life?',
    videoCTADesc: "Let's discuss your project and create something extraordinary together.",
    getQuote: 'Get a Quote',
    // Post Production Page
    postProductionTitle: 'Post Production',
    postProductionDesc1: 'Our post-production services transform raw footage into polished, professional content. We handle everything from color grading and audio mixing to visual effects and motion graphics.',
    postProductionDesc2: 'With state-of-the-art editing suites and experienced editors, we ensure your content meets the highest broadcast and digital standards.',
    // Post Production Services
    animationsVFXTitle: 'Animations & Visual Effects',
    animationsVFXDesc: 'Motion graphics, 3D animation, dynamic transitions, and cinematic color grading.',
    colorGradingTitle: 'Color Grading & Post-Production',
    colorGradingDesc: 'Professional color grading and editing services to enhance your video productions.',
    socialVidzz: 'SocialVidzz',
    socialVidzzDesc: 'Dynamic animations and social-ready video content with captivating transitions.',
    videoTestimonials: 'Video Testimonials',
    videoTestimonialsDesc: 'Professional testimonial videos featuring up to 3 people.',
    extraLanguageSupport: 'Extra Language Support',
    extraLanguageSupportDesc: 'Add additional language versions to your video content.',
    audioProductionTitle: 'Audio Production',
    audioProductionDesc: 'Professional audio mixing, sound design, and voiceover services for your video projects.',
    // Post Production Process
    postProductionProcess: 'Our Post-Production Process',
    importOrganize: 'Import & Organize',
    importOrganizeDesc: 'We import and organize all raw footage systematically',
    roughCut: 'Rough Cut',
    roughCutDesc: 'Creating the initial edit structure and flow',
    fineEditing: 'Fine Editing',
    fineEditingDesc: 'Precision editing with transitions and effects',
    colorSound: 'Color & Sound',
    colorSoundDesc: 'Final color grading and audio mastering',
    needPostProduction: 'Need professional post-production?',
    postProductionCTADesc: 'Let our experts transform your footage into stunning visual content.',
    startYourProject: 'Start Your Project',
    // On-Air Identity Page
    onAirIdentityTitle: 'On-Air Identity',
    onAirIdentityDesc1: 'We create distinctive on-air identities that capture attention and build brand recognition. From channel branding to program packaging, our designs make your content stand out.',
    onAirIdentityDesc2: 'Our team specializes in creating cohesive visual systems that work across all broadcast platforms.',
    // On-Air Services
    channelBrandingTitle: 'Channel Branding',
    channelBrandingDesc: 'Complete visual identity packages for TV channels including logos, color schemes, and brand guidelines.',
    identsBumpersTitle: 'Idents & Bumpers',
    identsBumpersDesc: 'Eye-catching station identifications and program bumpers that reinforce brand recognition.',
    lowerThirdsTitle: 'Lower Thirds & Graphics',
    lowerThirdsDesc: 'Professional on-screen graphics including lower thirds, tickers, and information displays.',
    showPackagingTitle: 'Show Packaging',
    showPackagingDesc: 'Complete visual packages for TV shows including openers, transitions, and end credits.',
    motionGraphicsTitle: 'Motion Graphics',
    motionGraphicsDesc: 'Dynamic animated elements that bring your broadcast to life with stunning visual effects.',
    promoProductionTitle: 'Promo Production',
    promoProductionDesc: 'Compelling promotional content to advertise upcoming programs and special events.',
    // On-Air Features
    logoDesign: 'Logo Design',
    brandGuidelines: 'Brand Guidelines',
    colorPalette: 'Color Palette',
    typographySystem: 'Typography System',
    stationIdents: 'Station Idents',
    programBumpers: 'Program Bumpers',
    sponsorTags: 'Sponsor Tags',
    breakStings: 'Break Stings',
    lowerThirds: 'Lower Thirds',
    newsTickers: 'News Tickers',
    scoreGraphics: 'Score Graphics',
    infoPanels: 'Info Panels',
    showOpeners: 'Show Openers',
    transitions: 'Transitions',
    endCredits: 'End Credits',
    segmentHeaders: 'Segment Headers',
    animatedLogos: 'Animated Logos',
    titleSequences: 'Title Sequences',
    visualEffects: 'Visual Effects',
    threeDElements: '3D Elements',
    showPromos: 'Show Promos',
    eventTeasers: 'Event Teasers',
    comingUpNext: 'Coming Up Next',
    specialAnnouncements: 'Special Announcements',
    // On-Air Process
    onAirProcess: 'Our On-Air Identity Process',
    discovery: 'Discovery',
    discoveryDesc: 'Understanding your brand and audience',
    concept: 'Concept',
    conceptDesc: 'Creative direction and style frames',
    design: 'Design',
    designDesc: 'Full graphic package development',
    deliveryProcess: 'Delivery',
    deliveryProcessDesc: 'Final assets in broadcast formats',
    readyElevateBroadcast: 'Ready to elevate your broadcast identity?',
    onAirCTADesc: "Let's create a distinctive on-air presence that captivates your audience.",
    // Marketing & Branding Page
    marketingBrandingTitle: 'Marketing & Branding',
    marketingBrandingDesc1: 'Strategic marketing and branding solutions that help your business grow. We develop comprehensive brand identities and marketing campaigns that resonate with your target audience.',
    marketingBrandingDesc2: 'From logo design to full marketing strategies, we help you build a strong, memorable brand presence.',
    // Marketing Services
    emailMarketingTitle: 'Email Marketing Campaigns',
    emailMarketingDesc: 'Targeted campaigns to build customer relationships, promote products, and drive conversions.',
    socialMediaMarketingTitle: 'Social Media Marketing',
    socialMediaMarketingDesc: 'Engaging content tailored for Facebook, Instagram, TikTok, and LinkedIn.',
    brandingTitle: 'Branding & Brand Development',
    brandingDesc: 'Strategic campaigns built around identity, promise, and uniqueness.',
    aiBotsTitle: 'AI Bots & Automation',
    aiBotsDesc: 'AI-powered chatbots for customer support, lead generation, and interactive marketing.',
    whyChooseMarketing: 'Why Choose Our Marketing Services?',
    dataDrivenStrategy: 'Data-Driven Strategy',
    dataDrivenStrategyDesc: 'We use analytics and insights to create campaigns that deliver measurable results.',
    creativeExcellence: 'Creative Excellence',
    creativeExcellenceDesc: 'Our team combines artistic vision with marketing expertise for standout campaigns.',
    fullServiceSupport: 'Full-Service Support',
    fullServiceSupportDesc: 'From strategy to execution, we handle every aspect of your marketing needs.',
    readyElevateBrand: 'Ready to elevate your brand?',
    marketingCTADesc: "Let's create a marketing strategy that drives results and builds lasting connections.",
    // Company Intro Section
    companyIntro1Title: 'CREATIVE VISION',
    companyIntro1Content: 'At Datasignz CreativeMinds, we believe every brand has a unique story waiting to be told. Our creative vision combines artistic excellence with strategic thinking to produce content that resonates with your audience and elevates your brand identity.',
    companyIntro2Title: 'EXPERT TEAM',
    companyIntro2Content: 'Our team of skilled professionals brings together expertise in video production, post-production, motion graphics, and digital marketing. With years of experience across various industries, we deliver exceptional results that exceed expectations.',
    companyIntro3Title: 'INNOVATION DRIVEN',
    companyIntro3Content: 'We stay at the forefront of technology and creative trends to bring you cutting-edge solutions. From AI-powered tools to the latest production techniques, we leverage innovation to give your brand a competitive edge in the digital landscape.',
    // Portfolio Section
    ourPortfolio: 'Our Portfolio',
    portfolioDesc: 'Explore our recent projects and see how we help brands come to life.',
    // Footer
    footerDesc: 'Datasignz CreativeMinds is a Paramaribo-based full-service creative and digital studio delivering high-impact visual storytelling, web solutions, marketing campaigns, and AI-driven tools that help brands build identity, engage audiences, and grow across platforms.',
    copyright: 'Copyright © 2026, Datasignz CreativeMinds. All Rights Reserved.',
    // Cookie Consent Banner
    cookieConsentTitle: 'We use cookies',
    cookieConsentDesc: 'We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking "Accept All", you consent to our use of cookies.',
    cookieAcceptAll: 'Accept All',
    cookieSettings: 'Settings',
    cookieDecline: 'Decline Optional',
    cookieSavePreferences: 'Save Preferences',
    cookieAlwaysOn: 'Always On',
    // Admin Dashboard
    adminLogin: 'Admin Login',
    adminLoginDesc: 'Enter the admin password to access the dashboard.',
    adminPassword: 'Password',
    adminLoginBtn: 'Login',
    adminBackToSite: 'Back to Website',
    adminWrongPassword: 'Incorrect password. Please try again.',
    adminDashboard: 'Admin Dashboard',
    adminRefresh: 'Refresh',
    adminLogout: 'Logout',
    adminContactSubmissions: 'Contact Submissions',
    adminBookingRequests: 'Booking Requests',
    adminNewsletterSubs: 'Newsletter Subscribers',
    adminContacts: 'Contacts',
    adminBookings: 'Bookings',
    adminSubscribers: 'Subscribers',
    adminNoContacts: 'No contact submissions yet.',
    adminNoBookings: 'No booking requests yet.',
    adminNoSubscribers: 'No newsletter subscribers yet.',
    adminDate: 'Date',
    adminSubmittedAt: 'Submitted At',
    adminSubscribedAt: 'Subscribed At',
    // Legal Pages - Privacy Policy
    privacyPolicyTitle: 'Privacy Policy',
    lastUpdated: 'Last updated:',
    january2025: 'January 2025',
    privacyIntroTitle: '1. Introduction',
    privacyIntroContent: 'Datasignz CreativeMinds ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you visit our website or use our services.',
    privacyCollectTitle: '2. Information We Collect',
    privacyCollectIntro: 'We may collect the following types of information:',
    privacyCollectPersonal: 'Personal Information:',
    privacyCollectPersonalDesc: 'Name, email address, phone number, and other contact details you provide through our forms.',
    privacyCollectUsage: 'Usage Data:',
    privacyCollectUsageDesc: 'Information about how you use our website, including pages visited, time spent, and navigation patterns.',
    privacyCollectTechnical: 'Technical Data:',
    privacyCollectTechnicalDesc: 'IP address, browser type, device information, and operating system.',
    privacyUseTitle: '3. How We Use Your Information',
    privacyUseIntro: 'We use your information to:',
    privacyUse1: 'Respond to your inquiries and provide customer support',
    privacyUse2: 'Process booking requests and consultations',
    privacyUse3: 'Send newsletters and marketing communications (with your consent)',
    privacyUse4: 'Improve our website and services',
    privacyUse5: 'Comply with legal obligations',
    privacySharingTitle: '4. Data Sharing',
    privacySharingContent: 'We do not sell your personal information. We may share your data with trusted third-party service providers who assist us in operating our website and conducting our business, subject to confidentiality agreements.',
    privacySecurityTitle: '5. Data Security',
    privacySecurityContent: 'We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.',
    privacyRightsTitle: '6. Your Rights',
    privacyRightsIntro: 'You have the right to:',
    privacyRights1: 'Access your personal data',
    privacyRights2: 'Correct inaccurate data',
    privacyRights3: 'Request deletion of your data',
    privacyRights4: 'Object to processing of your data',
    privacyRights5: 'Withdraw consent at any time',
    privacyContactTitle: '7. Contact Us',
    privacyContactIntro: 'If you have any questions about this Privacy Policy, please contact us at:',
    // Legal Pages - Terms of Service
    termsTitle: 'Terms of Service',
    termsAcceptTitle: '1. Acceptance of Terms',
    termsAcceptContent: 'By accessing and using the Datasignz CreativeMinds website and services, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.',
    termsServicesTitle: '2. Services',
    termsServicesContent: 'Datasignz CreativeMinds provides video production, post-production, on-air identity, marketing & branding, and web services. The specific terms for each project will be outlined in individual project agreements.',
    termsIPTitle: '3. Intellectual Property',
    termsIPContent: 'All content on this website, including text, graphics, logos, images, and software, is the property of Datasignz CreativeMinds and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.',
    termsUserTitle: '4. User Responsibilities',
    termsUserIntro: 'You agree to:',
    termsUser1: 'Provide accurate information when using our services',
    termsUser2: 'Not use our services for any unlawful purpose',
    termsUser3: 'Not interfere with the proper functioning of our website',
    termsUser4: 'Respect the intellectual property rights of others',
    termsPaymentTitle: '5. Payment Terms',
    termsPaymentContent: 'Payment terms for services will be specified in individual project agreements. Unless otherwise agreed, payments are due within 30 days of invoice date.',
    termsLiabilityTitle: '6. Limitation of Liability',
    termsLiabilityContent: 'Datasignz CreativeMinds shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services or website.',
    termsTerminationTitle: '7. Termination',
    termsTerminationContent: 'We reserve the right to terminate or suspend access to our services at any time, without prior notice, for conduct that we believe violates these Terms of Service or is harmful to other users.',
    termsGoverningTitle: '8. Governing Law',
    termsGoverningContent: 'These Terms of Service shall be governed by and construed in accordance with the laws of Suriname.',
    termsContactTitle: '9. Contact',
    termsContactContent: 'For questions about these Terms of Service, please contact us at brian@datasignz.nl.',
    // Legal Pages - Cookie Policy
    cookieTitle: 'Cookie Policy',
    cookieWhatTitle: '1. What Are Cookies',
    cookieWhatContent: 'Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and provide information to website owners.',
    cookieHowTitle: '2. How We Use Cookies',
    cookieHowIntro: 'We use cookies for the following purposes:',
    cookieEssential: 'Essential Cookies:',
    cookieEssentialDesc: 'Required for the website to function properly',
    cookieAnalytics: 'Analytics Cookies:',
    cookieAnalyticsDesc: 'Help us understand how visitors interact with our website',
    cookieFunctional: 'Functional Cookies:',
    cookieFunctionalDesc: 'Remember your preferences and settings',
    cookieMarketing: 'Marketing Cookies:',
    cookieMarketingDesc: 'Used to deliver relevant advertisements',
    cookieTypesTitle: '3. Types of Cookies We Use',
    cookieEssentialTitle: 'Essential Cookies',
    cookieEssentialContent: 'These cookies are necessary for the website to function and cannot be switched off. They are usually set in response to actions you take, such as setting your privacy preferences or filling in forms.',
    cookieAnalyticsTitle: 'Analytics Cookies',
    cookieAnalyticsContent: 'We use analytics services to help us understand how our website is being used. These cookies collect information about your use of the website, such as which pages you visit most often.',
    cookieThirdPartyTitle: 'Third-Party Cookies',
    cookieThirdPartyContent: 'Some cookies are placed by third-party services that appear on our pages, such as embedded videos from YouTube or social media sharing buttons.',
    cookieManagingTitle: '4. Managing Cookies',
    cookieManagingContent: 'Most web browsers allow you to control cookies through their settings. You can set your browser to refuse cookies or delete certain cookies. However, if you block or delete cookies, some features of our website may not function properly.',
    cookieBrowserTitle: '5. Browser Settings',
    cookieBrowserIntro: 'You can manage cookies in your browser settings:',
    cookieUpdatesTitle: '6. Updates to This Policy',
    cookieUpdatesContent: 'We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.',
    cookieContactTitle: '7. Contact Us',
    cookieContactContent: 'If you have questions about our use of cookies, please contact us at brian@datasignz.nl.',
    // Legal Pages - Disclaimer
    disclaimerTitle: 'Disclaimer',
    disclaimerGeneralTitle: '1. General Information',
    disclaimerGeneralContent: 'The information provided on this website is for general informational purposes only. While we strive to keep the information up to date and accurate, Datasignz CreativeMinds makes no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the website or the information, products, services, or related graphics contained on the website.',
    disclaimerAdviceTitle: '2. Professional Advice',
    disclaimerAdviceContent: 'The content on this website is not intended to be a substitute for professional advice. Always seek the advice of qualified professionals with any questions you may have regarding specific services or projects.',
    disclaimerLinksTitle: '3. External Links',
    disclaimerLinksContent: 'This website may contain links to external websites that are not provided or maintained by Datasignz CreativeMinds. We do not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.',
    disclaimerLiabilityTitle: '4. Limitation of Liability',
    disclaimerLiabilityContent: 'In no event shall Datasignz CreativeMinds be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.',
    disclaimerPortfolioTitle: '5. Portfolio and Sample Work',
    disclaimerPortfolioContent: 'The portfolio items and sample work displayed on this website are for demonstration purposes only. Results may vary depending on individual project requirements, specifications, and circumstances.',
    disclaimerAvailabilityTitle: '6. Availability',
    disclaimerAvailabilityContent: 'We do not guarantee that the website will be available at all times. We may experience hardware, software, or other problems, or need to perform maintenance related to the website, resulting in interruptions, delays, or errors.',
    disclaimerChangesTitle: '7. Changes',
    disclaimerChangesContent: 'Datasignz CreativeMinds reserves the right to make changes to this disclaimer at any time. Your continued use of the website following the posting of changes constitutes your acceptance of those changes.',
    disclaimerContactTitle: '8. Contact',
    disclaimerContactIntro: 'If you have any questions about this Disclaimer, please contact us at:',
  },
  nl: {
    // Navigation
    home: 'HOME',
    videoProduction: 'VIDEOPRODUCTIE',
    postProduction: 'POSTPRODUCTIE',
    onAirIdentity: 'ON-AIR IDENTITEIT',
    marketingBranding: 'MARKETING & BRANDING',
    webServices: 'WEBDIENSTEN',
    contact: 'CONTACT',
    search: 'Zoeken...',
    // Footer
    privacyPolicy: 'Privacybeleid',
    termsOfService: 'Servicevoorwaarden',
    cookiePolicy: 'Cookiebeleid',
    disclaimer: 'Disclaimer',
    allRightsReserved: 'Alle rechten voorbehouden',
    // Common
    getStarted: 'Aan de slag',
    learnMore: 'Meer informatie',
    sendMessage: 'Bericht versturen',
    bookConsultation: 'Consultatie boeken',
    subscribe: 'Abonneren',
    sitemap: 'Sitemap',
    legal: 'Juridisch',
    mostPopular: 'MEEST POPULAIR',
    delivery: 'Levering',
    days: 'dagen',
    additionalOptions: 'Extra Opties',
    webCtaTitle: 'Begin vandaag nog met het slimmer bouwen van uw website',
    webCtaButton: 'Consultatie boeken',
    // Extra Options
    extraVideoHeader: 'Video Header / Geanimeerde Header',
    extraVideoHeaderPrice: 'USD 50',
    extraSEO: 'Zoekmachine Optimalisatie',
    extraSEOPrice: 'USD 50',
    extraWhatsApp: 'WhatsApp Chat',
    extraWhatsAppPrice: 'USD 50',
    extraChatBot: 'Klantenservice Chatbot (AI)',
    extraChatBotPrice: 'USD 500',
    extraTVCommercial: 'Budget TV Commercial',
    extraTVCommercialPrice: 'USD 250 - 30s | USD 450 - 60s',
    extraLanguage: 'Extra Taal',
    extraLanguagePrice: 'USD 50 per taal',
    extraDomain: 'Domeinnaam Registratie',
    extraDomainPrice: 'Prijs op aanvraag',
    extraEcommerce: 'E-commerce Oplossingen',
    extraEcommercePrice: 'Prijs op aanvraag',
    extraTestimonials: 'Video Getuigenissen (3 personen)',
    extraTestimonialsPrice: 'USD 100',
    extraPhotography: 'Fotografie op Locatie',
    extraPhotographyPrice: 'USD 150',
    extraSearch: 'Zoekfunctie',
    extraSearchPrice: 'USD 50',
    extraAnalytics: 'Google Analytics',
    extraAnalyticsPrice: 'USD 25',
    extraAIGeneration: 'AI Afbeelding en Video Generatie',
    extraAIGenerationPrice: 'USD 50',
    // Portfolio Grid
    portfolioProductionSetup: 'Productie Setup',
    portfolioProfessionalLighting: 'Professionele Belichting',
    portfolioCinematographer: 'Cameraman',
    portfolioCameraSetup: 'Camera Setup',
    portfolioPostProduction: 'Postproductie',
    portfolioFX6Camera: 'FX6 Cinema Camera',
    // Hero Slider
    heroSlide1Name: 'TBL Cinemas',
    heroSlide1Desc: 'Merkidentiteit promo met slogan en korte versies voor social media',
    heroSlide2Name: 'Datasignz CreativeMinds Showreel',
    heroSlide2Desc: '',
    heroSlide3Name: 'Akira Overwater Resort',
    heroSlide3Desc: 'Promotievideo',
    heroSlide4Name: 'Birdland Suriname',
    heroSlide4Desc: 'Cock of the Rock',
    heroSlide5Name: 'BBC documentaire',
    heroSlide5Desc: 'Hoe de Amazone een veilige haven werd voor tot slaaf gemaakte Afrikanen',
    // Contact Page
    contactUs: 'Neem contact op',
    getInTouch: 'Neem Contact Op',
    sendUsMessage: 'Stuur ons een Bericht',
    name: 'Naam',
    email: 'E-mail',
    phone: 'Telefoon',
    subject: 'Onderwerp',
    message: 'Bericht',
    service: 'Dienst',
    preferredDate: 'Voorkeursdatum',
    additionalNotes: 'Aanvullende opmerkingen',
    pickDate: 'Kies een datum',
    sending: 'Verzenden...',
    booking: 'Boeken...',
    contactSubtitle: 'Klaar om uw visie tot leven te brengen? We horen graag van u.',
    bookConsultationTitle: 'Boek een Consultatie',
    contactInfo: 'Contactgegevens',
    subscribeNewsletter: 'Abonneer op Onze Nieuwsbrief',
    newsletterDesc: 'Blijf op de hoogte van onze laatste projecten en aanbiedingen.',
    visitUs: 'Bezoek Ons',
    // Services
    selectService: 'Selecteer een dienst',
    videoService: 'Videoproductie',
    postService: 'Postproductie',
    marketingService: 'Marketing & Branding',
    webService: 'Webdiensten',
    // Home Page
    welcomeTitle: 'Welkom bij Datasignz CreativeMinds',
    welcomeSubtitle: 'Uw Partner in Creatieve Excellentie',
    ourWork: 'Ons Werk',
    ourServices: 'Onze Diensten',
    viewPortfolio: 'Bekijk Portfolio',
    // Web Services Page
    webServicesTitle: 'Webdiensten door NeuralNext',
    webServicesDesc1: 'NeuralNext is een vooruitstrevende digitale oplossingendivisie binnen Datasignz CreativeMinds, gericht op het bouwen van intelligente websites en applicaties die zich aanpassen, leren en presteren. Als gespecialiseerde divisie van Datasignz CreativeMinds combineert NeuralNext geavanceerde automatisering, datagestuurde logica en mensgerichte design om platforms te leveren die slimmer werken en sneller schalen.',
    webServicesDesc2: 'We ontwikkelen niet alleen digitale producten — we engineeren responsieve ecosystemen die gebruikersgedrag anticiperen, operaties stroomlijnen en meetbare groei ontsluiten. Van concept tot implementatie transformeert NeuralNext complexiteit naar naadloze digitale ervaringen gebouwd voor de toekomst.',
    webServicesDesc3: 'Een kerncomponent van deze aanpak is de strategische inzet van conversatie-interfaces. Intelligente chatbots breiden uw digitale aanwezigheid uit voorbij statische interactie door real-time engagement, geautomatiseerde klantenondersteuning en begeleide gebruikersreizen op schaal te bieden.',
    webServicesDesc4: 'Door routinevragen af te handelen, leads te kwalificeren en direct te integreren met interne systemen, verminderen chatbots operationele wrijving, verbeteren responstijden en genereren actionable inzichten. Het resultaat is verhoogde efficiëntie, hogere conversiepercentages en een consistent toegankelijke klantervaring, zonder extra overhead.',
    webServicesCTA: 'Probeer het zelf. Klik op het zwart-witte icoon in de rechteronderhoek.',
    ourPortfolio: 'Onze portfolio',
    // Web Services Packages
    landingPage: 'Landingspagina',
    websiteBudget: 'Website Budget',
    websiteStandard: 'Website Standaard',
    websiteElite: 'Website Elite',
    basicDesign: 'Basis ontwerp',
    responsiveLayout: 'Responsieve lay-out',
    contactForm: 'Contactformulier',
    socialMediaIntegration: 'Social media integratie',
    photoGallery: 'Fotogalerij',
    fourPages: '4 pagina\'s',
    bookingsForm: 'Boekingsformulier',
    customDesign: 'Aangepast ontwerp passend bij branding',
    maxTenPages: 'Maximaal 10 pagina\'s',
    photoGalleryVideo: 'Fotogalerij & videolinks',
    bookingQuoteForm: 'Boeking/Offerte formulier',
    maxTwentyFivePages: 'Maximaal 25 pagina\'s',
    videoHeader: 'Video Header / Geanimeerde Header',
    seoTitle: 'Zoekmachineoptimalisatie',
    searchFunction: 'Zoekfunctie',
    whatsappChat: 'WhatsApp Chat Integratie',
    googleAnalytics: 'Google Analytics',
    aiImageVideo: 'AI Afbeelding en Video Generatie',
    ecommerceSolutions: 'E-commerce Oplossingen',
    domainHosting: 'Domeinregistratie & Hosting',
    priceOnRequest: 'Prijs op aanvraag',
    webDevProcess: 'Ons Webontwikkelingsproces',
    planning: 'Planning',
    planningDesc: 'Doelen & vereisten definiëren',
    designStep: 'Ontwerp',
    designStepDesc: 'UI/UX & visuele identiteit',
    development: 'Ontwikkeling',
    developmentDesc: 'Uw website bouwen',
    testing: 'Testen',
    testingDesc: 'Kwaliteitsborging',
    launch: 'Lancering',
    launchDesc: 'Live gaan & ondersteuning',
    // CTA Section
    ctaTitle: 'Klaar om uw visie tot leven te brengen?',
    ctaSubtitle: 'Laten we uw project bespreken en samen iets bijzonders creëren.',
    getQuote: 'Offerte Aanvragen',
    // Video Production Page
    videoProductionTitle: 'Videoproductie',
    videoProductionDesc1: 'Datasignz Creative Minds brengt verhalen tot leven door doelgerichte, impactvolle videoproductie. We creëren visuele content die meer doet dan er goed uitzien — het communiceert, overtuigt en presteert. Van merkfilms en commercials tot bedrijfsvideo\'s en digitale content, elke productie is strategisch ontworpen om uw boodschap te versterken en uw merk te verhogen.',
    videoProductionDesc2: 'Met een scherpe creatieve visie en een resultaatgerichte aanpak combineren we storytelling, cinematografie en postproductie-expertise om video\'s te leveren die verbinden met uw publiek en uw bedrijfsdoelstellingen ondersteunen. Of u nu een merk lanceert, een dienst promoot of langetermijnzichtbaarheid opbouwt, Datasignz Creative Minds transformeert ideeën in overtuigende visuele ervaringen.',
    featuredClients: 'Uitgelichte klanten:',
    // Video Production Services
    tvCommercialsTitle: 'TV Commercials & Reclame',
    tvCommercialsDesc: 'Professionele commercials voor retail, automotive, horeca en zakelijke klanten.',
    corporateFilmsTitle: 'Bedrijfsfilms & Mood Video\'s',
    corporateFilmsDesc: 'Identiteitsgerichte producties die bedrijfscultuur, waarden en merkbelofte benadrukken.',
    musicVideosTitle: 'Muziekvideo\'s',
    musicVideosDesc: 'Creatieve samenwerkingen met artiesten om hun visie tot leven te brengen.',
    documentariesTitle: 'Documentaires & Korte Films',
    documentariesDesc: 'Culturele, milieu- en sociale thema\'s behandelen met cinematografische kwaliteit.',
    promoVideosTitle: 'Promotievideo\'s',
    promoVideosDesc: 'Promotiefilms voor merken, projecten en evenementen.',
    afterMoviesTitle: 'Aftermovies / Evenementvideo\'s',
    afterMoviesDesc: 'Samenvattingsvideo\'s van evenementen die de energie en hoogtepunten vastleggen.',
    readyBringVision: 'Klaar om uw visie tot leven te brengen?',
    videoCTADesc: 'Laten we uw project bespreken en samen iets bijzonders creëren.',
    getQuote: 'Offerte Aanvragen',
    // Post Production Page
    postProductionTitle: 'Postproductie',
    postProductionDesc1: 'Onze postproductiediensten transformeren ruwe beelden in gepolijste, professionele content. We behandelen alles van kleurcorrectie en audiomixing tot visuele effecten en motion graphics.',
    postProductionDesc2: 'Met state-of-the-art bewerkingssuites en ervaren editors zorgen we ervoor dat uw content voldoet aan de hoogste broadcast- en digitale standaarden.',
    // Post Production Services
    animationsVFXTitle: 'Animaties & Visuele Effecten',
    animationsVFXDesc: 'Motion graphics, 3D-animatie, dynamische overgangen en cinematografische kleurcorrectie.',
    colorGradingTitle: 'Kleurcorrectie & Postproductie',
    colorGradingDesc: 'Professionele kleurcorrectie en bewerkingsdiensten om uw videoproducties te verbeteren.',
    socialVidzz: 'SocialVidzz',
    socialVidzzDesc: 'Dynamische animaties en social-ready videocontent met boeiende overgangen.',
    videoTestimonials: 'Video Testimonials',
    videoTestimonialsDesc: 'Professionele testimonialvideo\'s met maximaal 3 personen.',
    extraLanguageSupport: 'Extra Taalondersteuning',
    extraLanguageSupportDesc: 'Voeg extra taalversies toe aan uw videocontent.',
    audioProductionTitle: 'Audioproductie',
    audioProductionDesc: 'Professionele audiomixing, geluidsontwerp en voice-over diensten voor uw videoprojecten.',
    postProductionProcess: 'Ons Postproductieproces',
    importOrganize: 'Importeren & Organiseren',
    importOrganizeDesc: 'We importeren en organiseren alle ruwe beelden systematisch',
    roughCut: 'Ruwe Montage',
    roughCutDesc: 'Creëren van de initiële bewerkingsstructuur en flow',
    fineEditing: 'Fijne Bewerking',
    fineEditingDesc: 'Precisiebewerking met overgangen en effecten',
    colorSound: 'Kleur & Geluid',
    colorSoundDesc: 'Definitieve kleurcorrectie en audiomastering',
    needPostProduction: 'Heeft u professionele postproductie nodig?',
    postProductionCTADesc: 'Laat onze experts uw beelden transformeren naar verbluffende visuele content.',
    startYourProject: 'Start Uw Project',
    // On-Air Identity Page
    onAirIdentityTitle: 'On-Air Identiteit',
    onAirIdentityDesc1: 'We creëren onderscheidende on-air identiteiten die aandacht trekken en merkherkenning opbouwen. Van zenderbranding tot programmaverpakking, onze ontwerpen laten uw content opvallen.',
    onAirIdentityDesc2: 'Ons team is gespecialiseerd in het creëren van samenhangende visuele systemen die werken op alle broadcastplatforms.',
    // On-Air Services
    channelBrandingTitle: 'Zenderbranding',
    channelBrandingDesc: 'Complete visuele identiteitspakketten voor TV-zenders inclusief logo\'s, kleurenschema\'s en merkrichtlijnen.',
    identsBumpersTitle: 'Idents & Bumpers',
    identsBumpersDesc: 'Opvallende zenderidentificaties en programmabumpers die merkherkenning versterken.',
    lowerThirdsTitle: 'Lower Thirds & Graphics',
    lowerThirdsDesc: 'Professionele on-screen graphics inclusief lower thirds, tickers en informatiedisplays.',
    showPackagingTitle: 'Showverpakking',
    showPackagingDesc: 'Complete visuele pakketten voor TV-shows inclusief openers, overgangen en aftiteling.',
    motionGraphicsTitle: 'Motion Graphics',
    motionGraphicsDesc: 'Dynamische geanimeerde elementen die uw uitzending tot leven brengen met verbluffende visuele effecten.',
    promoProductionTitle: 'Promoproductie',
    promoProductionDesc: 'Overtuigende promotionele content om aankomende programma\'s en speciale evenementen aan te kondigen.',
    logoDesign: 'Logo-ontwerp',
    brandGuidelines: 'Merkrichtlijnen',
    colorPalette: 'Kleurenpalet',
    typographySystem: 'Typografiesysteem',
    stationIdents: 'Zenderidents',
    programBumpers: 'Programmabumpers',
    sponsorTags: 'Sponsortags',
    breakStings: 'Break Stings',
    lowerThirds: 'Lower Thirds',
    newsTickers: 'Nieuwstickers',
    scoreGraphics: 'Scoregraphics',
    infoPanels: 'Infopanelen',
    showOpeners: 'Show Openers',
    transitions: 'Overgangen',
    endCredits: 'Aftiteling',
    segmentHeaders: 'Segmentkoppen',
    animatedLogos: 'Geanimeerde Logo\'s',
    titleSequences: 'Titelsequenties',
    visualEffects: 'Visuele Effecten',
    threeDElements: '3D-elementen',
    showPromos: 'Showpromo\'s',
    eventTeasers: 'Evenementteasers',
    comingUpNext: 'Straks',
    specialAnnouncements: 'Speciale Aankondigingen',
    onAirProcess: 'Ons On-Air Identiteitsproces',
    discovery: 'Ontdekking',
    discoveryDesc: 'Uw merk en publiek begrijpen',
    concept: 'Concept',
    conceptDesc: 'Creatieve richting en stijlframes',
    design: 'Ontwerp',
    designDesc: 'Volledige grafische pakketontwikkeling',
    deliveryProcess: 'Levering',
    deliveryProcessDesc: 'Definitieve assets in broadcastformaten',
    readyElevateBroadcast: 'Klaar om uw broadcastidentiteit te verhogen?',
    onAirCTADesc: 'Laten we een onderscheidende on-air aanwezigheid creëren die uw publiek boeit.',
    // Marketing & Branding Page
    marketingBrandingTitle: 'Marketing & Branding',
    marketingBrandingDesc1: 'Strategische marketing- en brandingoplossingen die uw bedrijf helpen groeien. We ontwikkelen uitgebreide merkidentiteiten en marketingcampagnes die resoneren met uw doelgroep.',
    marketingBrandingDesc2: 'Van logo-ontwerp tot volledige marketingstrategieën, we helpen u een sterke, gedenkwaardige merkpositie op te bouwen.',
    // Marketing Services
    emailMarketingTitle: 'E-mail Marketing Campagnes',
    emailMarketingDesc: 'Gerichte campagnes om klantrelaties op te bouwen, producten te promoten en conversies te stimuleren.',
    socialMediaMarketingTitle: 'Social Media Marketing',
    socialMediaMarketingDesc: 'Boeiende content op maat voor Facebook, Instagram, TikTok en LinkedIn.',
    brandingTitle: 'Branding & Merkontwikkeling',
    brandingDesc: 'Strategische campagnes gebouwd rond identiteit, belofte en uniekheid.',
    aiBotsTitle: 'AI Bots & Automatisering',
    aiBotsDesc: 'AI-aangedreven chatbots voor klantenondersteuning, leadgeneratie en interactieve marketing.',
    whyChooseMarketing: 'Waarom Kiezen voor Onze Marketing Diensten?',
    dataDrivenStrategy: 'Datagestuurde Strategie',
    dataDrivenStrategyDesc: 'We gebruiken analyses en inzichten om campagnes te creëren die meetbare resultaten leveren.',
    creativeExcellence: 'Creatieve Excellentie',
    creativeExcellenceDesc: 'Ons team combineert artistieke visie met marketingexpertise voor opvallende campagnes.',
    fullServiceSupport: 'Full-Service Ondersteuning',
    fullServiceSupportDesc: 'Van strategie tot uitvoering, we behandelen elk aspect van uw marketingbehoeften.',
    readyElevateBrand: 'Klaar om uw merk te verhogen?',
    marketingCTADesc: 'Laten we een marketingstrategie creëren die resultaten oplevert en duurzame connecties opbouwt.',
    // Company Intro Section
    companyIntro1Title: 'CREATIEVE VISIE',
    companyIntro1Content: 'Bij Datasignz CreativeMinds geloven we dat elk merk een uniek verhaal heeft dat wacht om verteld te worden. Onze creatieve visie combineert artistieke excellentie met strategisch denken om content te produceren die resoneert met uw publiek en uw merkidentiteit verhoogt.',
    companyIntro2Title: 'EXPERT TEAM',
    companyIntro2Content: 'Ons team van bekwame professionals brengt expertise samen in videoproductie, postproductie, motion graphics en digitale marketing. Met jarenlange ervaring in diverse branches leveren we uitzonderlijke resultaten die verwachtingen overtreffen.',
    companyIntro3Title: 'INNOVATIE GEDREVEN',
    companyIntro3Content: 'We blijven voorop lopen in technologie en creatieve trends om u baanbrekende oplossingen te bieden. Van AI-aangedreven tools tot de nieuwste productietechnieken, we benutten innovatie om uw merk een concurrentievoordeel te geven in het digitale landschap.',
    // Portfolio Section
    ourPortfolio: 'Onze portfolio',
    portfolioDesc: 'Ontdek onze recente projecten en zie hoe we merken tot leven brengen.',
    // Footer
    footerDesc: 'Datasignz CreativeMinds is een in Paramaribo gevestigde full-service creatieve en digitale studio die impactvolle visuele storytelling, weboplossingen, marketingcampagnes en AI-gestuurde tools levert die merken helpen identiteit op te bouwen, doelgroepen te betrekken en te groeien op alle platforms.',
    copyright: 'Copyright © 2026, Datasignz CreativeMinds. Alle Rechten Voorbehouden.',
    // Cookie Consent Banner
    cookieConsentTitle: 'Wij gebruiken cookies',
    cookieConsentDesc: 'Wij gebruiken cookies om uw browse-ervaring te verbeteren, siteverkeer te analyseren en content te personaliseren. Door op "Alles accepteren" te klikken, stemt u in met ons gebruik van cookies.',
    cookieAcceptAll: 'Alles Accepteren',
    cookieSettings: 'Instellingen',
    cookieDecline: 'Optionele Weigeren',
    cookieSavePreferences: 'Voorkeuren Opslaan',
    cookieAlwaysOn: 'Altijd Aan',
    // Admin Dashboard
    adminLogin: 'Admin Login',
    adminLoginDesc: 'Voer het admin wachtwoord in om toegang te krijgen tot het dashboard.',
    adminPassword: 'Wachtwoord',
    adminLoginBtn: 'Inloggen',
    adminBackToSite: 'Terug naar Website',
    adminWrongPassword: 'Onjuist wachtwoord. Probeer het opnieuw.',
    adminDashboard: 'Admin Dashboard',
    adminRefresh: 'Vernieuwen',
    adminLogout: 'Uitloggen',
    adminContactSubmissions: 'Contactformulieren',
    adminBookingRequests: 'Boekingsverzoeken',
    adminNewsletterSubs: 'Nieuwsbrief Abonnees',
    adminContacts: 'Contacten',
    adminBookings: 'Boekingen',
    adminSubscribers: 'Abonnees',
    adminNoContacts: 'Nog geen contactformulieren.',
    adminNoBookings: 'Nog geen boekingsverzoeken.',
    adminNoSubscribers: 'Nog geen nieuwsbrief abonnees.',
    adminDate: 'Datum',
    adminSubmittedAt: 'Ingediend Op',
    adminSubscribedAt: 'Geabonneerd Op',
    // Legal Pages - Privacy Policy
    privacyPolicyTitle: 'Privacybeleid',
    lastUpdated: 'Laatst bijgewerkt:',
    january2025: 'Januari 2025',
    privacyIntroTitle: '1. Inleiding',
    privacyIntroContent: 'Datasignz CreativeMinds ("wij," "onze," of "ons") respecteert uw privacy en is toegewijd aan het beschermen van uw persoonlijke gegevens. Dit privacybeleid legt uit hoe we uw informatie verzamelen, gebruiken en beschermen wanneer u onze website bezoekt of onze diensten gebruikt.',
    privacyCollectTitle: '2. Informatie die we verzamelen',
    privacyCollectIntro: 'We kunnen de volgende soorten informatie verzamelen:',
    privacyCollectPersonal: 'Persoonlijke Informatie:',
    privacyCollectPersonalDesc: 'Naam, e-mailadres, telefoonnummer en andere contactgegevens die u via onze formulieren verstrekt.',
    privacyCollectUsage: 'Gebruiksgegevens:',
    privacyCollectUsageDesc: 'Informatie over hoe u onze website gebruikt, inclusief bezochte paginas, bestede tijd en navigatiepatronen.',
    privacyCollectTechnical: 'Technische Gegevens:',
    privacyCollectTechnicalDesc: 'IP-adres, browsertype, apparaatinformatie en besturingssysteem.',
    privacyUseTitle: '3. Hoe we uw informatie gebruiken',
    privacyUseIntro: 'We gebruiken uw informatie om:',
    privacyUse1: 'Op uw vragen te reageren en klantenservice te bieden',
    privacyUse2: 'Boekingsverzoeken en consultaties te verwerken',
    privacyUse3: 'Nieuwsbrieven en marketingcommunicatie te versturen (met uw toestemming)',
    privacyUse4: 'Onze website en diensten te verbeteren',
    privacyUse5: 'Te voldoen aan wettelijke verplichtingen',
    privacySharingTitle: '4. Gegevens delen',
    privacySharingContent: 'We verkopen uw persoonlijke informatie niet. We kunnen uw gegevens delen met vertrouwde externe dienstverleners die ons helpen bij het beheren van onze website en het uitvoeren van onze activiteiten, onder voorbehoud van vertrouwelijkheidsovereenkomsten.',
    privacySecurityTitle: '5. Gegevensbeveiliging',
    privacySecurityContent: 'We implementeren passende technische en organisatorische maatregelen om uw persoonlijke gegevens te beschermen tegen ongeautoriseerde toegang, wijziging, openbaarmaking of vernietiging.',
    privacyRightsTitle: '6. Uw rechten',
    privacyRightsIntro: 'U heeft het recht om:',
    privacyRights1: 'Toegang te krijgen tot uw persoonlijke gegevens',
    privacyRights2: 'Onjuiste gegevens te corrigeren',
    privacyRights3: 'Verwijdering van uw gegevens te verzoeken',
    privacyRights4: 'Bezwaar te maken tegen verwerking van uw gegevens',
    privacyRights5: 'Toestemming op elk moment in te trekken',
    privacyContactTitle: '7. Neem contact met ons op',
    privacyContactIntro: 'Als u vragen heeft over dit Privacybeleid, neem dan contact met ons op via:',
    // Legal Pages - Terms of Service
    termsTitle: 'Servicevoorwaarden',
    termsAcceptTitle: '1. Acceptatie van voorwaarden',
    termsAcceptContent: 'Door toegang te krijgen tot en gebruik te maken van de Datasignz CreativeMinds website en diensten, accepteert u en stemt u ermee in gebonden te zijn aan deze Servicevoorwaarden. Als u niet akkoord gaat met deze voorwaarden, gebruik dan onze diensten niet.',
    termsServicesTitle: '2. Diensten',
    termsServicesContent: 'Datasignz CreativeMinds biedt videoproductie, postproductie, on-air identiteit, marketing & branding en webdiensten. De specifieke voorwaarden voor elk project worden uiteengezet in individuele projectovereenkomsten.',
    termsIPTitle: '3. Intellectueel eigendom',
    termsIPContent: 'Alle inhoud op deze website, inclusief tekst, afbeeldingen, logos, beelden en software, is eigendom van Datasignz CreativeMinds en wordt beschermd door auteurswet en andere intellectuele eigendomswetten. U mag niet reproduceren, distribueren of afgeleide werken maken zonder onze uitdrukkelijke schriftelijke toestemming.',
    termsUserTitle: '4. Gebruikersverantwoordelijkheden',
    termsUserIntro: 'U stemt ermee in om:',
    termsUser1: 'Accurate informatie te verstrekken bij gebruik van onze diensten',
    termsUser2: 'Onze diensten niet te gebruiken voor onwettige doeleinden',
    termsUser3: 'Niet te interfereren met de goede werking van onze website',
    termsUser4: 'De intellectuele eigendomsrechten van anderen te respecteren',
    termsPaymentTitle: '5. Betalingsvoorwaarden',
    termsPaymentContent: 'Betalingsvoorwaarden voor diensten worden gespecificeerd in individuele projectovereenkomsten. Tenzij anders overeengekomen, zijn betalingen verschuldigd binnen 30 dagen na factuurdatum.',
    termsLiabilityTitle: '6. Beperking van aansprakelijkheid',
    termsLiabilityContent: 'Datasignz CreativeMinds is niet aansprakelijk voor enige indirecte, incidentele, speciale, gevolg- of punitieve schade die voortvloeit uit uw gebruik van onze diensten of website.',
    termsTerminationTitle: '7. Beëindiging',
    termsTerminationContent: 'We behouden ons het recht voor om toegang tot onze diensten op elk moment te beëindigen of op te schorten, zonder voorafgaande kennisgeving, voor gedrag waarvan wij geloven dat het deze Servicevoorwaarden schendt of schadelijk is voor andere gebruikers.',
    termsGoverningTitle: '8. Toepasselijk recht',
    termsGoverningContent: 'Deze Servicevoorwaarden worden beheerst door en geïnterpreteerd in overeenstemming met de wetten van Suriname.',
    termsContactTitle: '9. Contact',
    termsContactContent: 'Voor vragen over deze Servicevoorwaarden kunt u contact met ons opnemen via brian@datasignz.nl.',
    // Legal Pages - Cookie Policy
    cookieTitle: 'Cookiebeleid',
    cookieWhatTitle: '1. Wat zijn cookies',
    cookieWhatContent: 'Cookies zijn kleine tekstbestanden die op uw computer of mobiel apparaat worden geplaatst wanneer u een website bezoekt. Ze worden veel gebruikt om websites efficiënter te laten werken en informatie te verstrekken aan website-eigenaren.',
    cookieHowTitle: '2. Hoe we cookies gebruiken',
    cookieHowIntro: 'We gebruiken cookies voor de volgende doeleinden:',
    cookieEssential: 'Essentiële Cookies:',
    cookieEssentialDesc: 'Vereist voor het goed functioneren van de website',
    cookieAnalytics: 'Analytics Cookies:',
    cookieAnalyticsDesc: 'Helpen ons begrijpen hoe bezoekers interacteren met onze website',
    cookieFunctional: 'Functionele Cookies:',
    cookieFunctionalDesc: 'Onthouden uw voorkeuren en instellingen',
    cookieMarketing: 'Marketing Cookies:',
    cookieMarketingDesc: 'Gebruikt om relevante advertenties te leveren',
    cookieTypesTitle: '3. Soorten cookies die we gebruiken',
    cookieEssentialTitle: 'Essentiële Cookies',
    cookieEssentialContent: 'Deze cookies zijn noodzakelijk voor het functioneren van de website en kunnen niet worden uitgeschakeld. Ze worden meestal ingesteld als reactie op acties die u onderneemt, zoals het instellen van uw privacyvoorkeuren of het invullen van formulieren.',
    cookieAnalyticsTitle: 'Analytics Cookies',
    cookieAnalyticsContent: 'We gebruiken analysediensten om ons te helpen begrijpen hoe onze website wordt gebruikt. Deze cookies verzamelen informatie over uw gebruik van de website, zoals welke paginas u het vaakst bezoekt.',
    cookieThirdPartyTitle: 'Cookies van derden',
    cookieThirdPartyContent: 'Sommige cookies worden geplaatst door diensten van derden die op onze paginas verschijnen, zoals ingesloten videos van YouTube of deelknoppen voor sociale media.',
    cookieManagingTitle: '4. Cookies beheren',
    cookieManagingContent: 'De meeste webbrowsers stellen u in staat cookies te beheren via hun instellingen. U kunt uw browser instellen om cookies te weigeren of bepaalde cookies te verwijderen. Als u cookies blokkeert of verwijdert, werken sommige functies van onze website mogelijk niet correct.',
    cookieBrowserTitle: '5. Browserinstellingen',
    cookieBrowserIntro: 'U kunt cookies beheren in uw browserinstellingen:',
    cookieUpdatesTitle: '6. Updates van dit beleid',
    cookieUpdatesContent: 'We kunnen dit Cookiebeleid van tijd tot tijd bijwerken. Eventuele wijzigingen worden op deze pagina geplaatst met een bijgewerkte herzieningsdatum.',
    cookieContactTitle: '7. Neem contact met ons op',
    cookieContactContent: 'Als u vragen heeft over ons gebruik van cookies, neem dan contact met ons op via brian@datasignz.nl.',
    // Legal Pages - Disclaimer
    disclaimerTitle: 'Disclaimer',
    disclaimerGeneralTitle: '1. Algemene informatie',
    disclaimerGeneralContent: 'De informatie op deze website is uitsluitend bedoeld voor algemene informatiedoeleinden. Hoewel we ernaar streven de informatie actueel en nauwkeurig te houden, doet Datasignz CreativeMinds geen verklaringen of garanties van welke aard dan ook, expliciet of impliciet, over de volledigheid, nauwkeurigheid, betrouwbaarheid, geschiktheid of beschikbaarheid van de website of de informatie, producten, diensten of gerelateerde afbeeldingen op de website.',
    disclaimerAdviceTitle: '2. Professioneel advies',
    disclaimerAdviceContent: 'De inhoud op deze website is niet bedoeld als vervanging voor professioneel advies. Raadpleeg altijd gekwalificeerde professionals voor vragen over specifieke diensten of projecten.',
    disclaimerLinksTitle: '3. Externe links',
    disclaimerLinksContent: 'Deze website kan links bevatten naar externe websites die niet door Datasignz CreativeMinds worden aangeboden of onderhouden. We garanderen niet de nauwkeurigheid, relevantie, actualiteit of volledigheid van informatie op deze externe websites.',
    disclaimerLiabilityTitle: '4. Beperking van aansprakelijkheid',
    disclaimerLiabilityContent: 'In geen geval is Datasignz CreativeMinds aansprakelijk voor enig verlies of schade, inclusief maar niet beperkt tot indirecte of gevolgschade, of enig verlies of schade die voortvloeit uit verlies van gegevens of winst als gevolg van of in verband met het gebruik van deze website.',
    disclaimerPortfolioTitle: '5. Portfolio en voorbeeldwerk',
    disclaimerPortfolioContent: 'De portfolio-items en voorbeeldwerken die op deze website worden weergegeven, zijn uitsluitend bedoeld voor demonstratiedoeleinden. Resultaten kunnen variëren afhankelijk van individuele projectvereisten, specificaties en omstandigheden.',
    disclaimerAvailabilityTitle: '6. Beschikbaarheid',
    disclaimerAvailabilityContent: 'We garanderen niet dat de website te allen tijde beschikbaar is. We kunnen hardware-, software- of andere problemen ondervinden, of onderhoud moeten uitvoeren gerelateerd aan de website, wat kan resulteren in onderbrekingen, vertragingen of fouten.',
    disclaimerChangesTitle: '7. Wijzigingen',
    disclaimerChangesContent: 'Datasignz CreativeMinds behoudt zich het recht voor om op elk moment wijzigingen aan te brengen in deze disclaimer. Uw voortgezet gebruik van de website na het plaatsen van wijzigingen vormt uw acceptatie van die wijzigingen.',
    disclaimerContactTitle: '8. Contact',
    disclaimerContactIntro: 'Als u vragen heeft over deze Disclaimer, neem dan contact met ons op via:',
  },
  es: {
    // Navigation
    home: 'INICIO',
    videoProduction: 'PRODUCCIÓN DE VIDEO',
    postProduction: 'POSTPRODUCCIÓN',
    onAirIdentity: 'IDENTIDAD EN PANTALLA',
    marketingBranding: 'MARKETING Y MARCA',
    webServices: 'SERVICIOS WEB',
    contact: 'CONTACTO',
    search: 'Buscar...',
    // Footer
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    cookiePolicy: 'Política de Cookies',
    disclaimer: 'Aviso Legal',
    allRightsReserved: 'Todos los derechos reservados',
    // Common
    getStarted: 'Empezar',
    learnMore: 'Más información',
    sendMessage: 'Enviar mensaje',
    bookConsultation: 'Reservar consulta',
    subscribe: 'Suscribirse',
    sitemap: 'Mapa del sitio',
    legal: 'Legal',
    mostPopular: 'MÁS POPULAR',
    delivery: 'Entrega',
    days: 'días',
    additionalOptions: 'Opciones Adicionales',
    webCtaTitle: 'Comienza hoy a construir tu sitio web de manera más inteligente',
    webCtaButton: 'Reservar Consulta',
    // Extra Options
    extraVideoHeader: 'Encabezado de Video / Encabezado Animado',
    extraVideoHeaderPrice: 'USD 50',
    extraSEO: 'Optimización de Motores de Búsqueda',
    extraSEOPrice: 'USD 50',
    extraWhatsApp: 'Chat de WhatsApp',
    extraWhatsAppPrice: 'USD 50',
    extraChatBot: 'Chatbot de Servicio al Cliente (IA)',
    extraChatBotPrice: 'USD 500',
    extraTVCommercial: 'Comercial de TV Económico',
    extraTVCommercialPrice: 'USD 250 - 30s | USD 450 - 60s',
    extraLanguage: 'Idioma Extra',
    extraLanguagePrice: 'USD 50 por idioma',
    extraDomain: 'Registro de Nombre de Dominio',
    extraDomainPrice: 'Precio a consultar',
    extraEcommerce: 'Soluciones de E-commerce',
    extraEcommercePrice: 'Precio a consultar',
    extraTestimonials: 'Testimonios en Video (3 personas)',
    extraTestimonialsPrice: 'USD 100',
    extraPhotography: 'Fotografía en Ubicación',
    extraPhotographyPrice: 'USD 150',
    extraSearch: 'Función de Búsqueda',
    extraSearchPrice: 'USD 50',
    extraAnalytics: 'Google Analytics',
    extraAnalyticsPrice: 'USD 25',
    extraAIGeneration: 'Generación de Imágenes y Videos con IA',
    extraAIGenerationPrice: 'USD 50',
    // Portfolio Grid
    portfolioProductionSetup: 'Configuración de Producción',
    portfolioProfessionalLighting: 'Iluminación Profesional',
    portfolioCinematographer: 'Cinematógrafo',
    portfolioCameraSetup: 'Configuración de Cámara',
    portfolioPostProduction: 'Postproducción',
    portfolioFX6Camera: 'Cámara de Cine FX6',
    // Hero Slider
    heroSlide1Name: 'TBL Cinemas',
    heroSlide1Desc: 'Promo de identidad de marca con eslogan y versiones cortas para redes sociales',
    heroSlide2Name: 'Datasignz CreativeMinds Showreel',
    heroSlide2Desc: '',
    heroSlide3Name: 'Akira Overwater Resort',
    heroSlide3Desc: 'Video promocional',
    heroSlide4Name: 'Birdland Surinam',
    heroSlide4Desc: 'Gallito de las Rocas',
    heroSlide5Name: 'Documental de la BBC',
    heroSlide5Desc: 'Cómo la Amazonía se convirtió en un refugio seguro para africanos esclavizados',
    // Contact Page
    contactUs: 'Contáctenos',
    getInTouch: 'Ponte en Contacto',
    sendUsMessage: 'Envíanos un Mensaje',
    name: 'Nombre',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    subject: 'Asunto',
    message: 'Mensaje',
    service: 'Servicio',
    preferredDate: 'Fecha preferida',
    additionalNotes: 'Notas adicionales',
    pickDate: 'Elige una fecha',
    sending: 'Enviando...',
    booking: 'Reservando...',
    contactSubtitle: '¿Listo para dar vida a tu visión? Nos encantaría saber de ti.',
    bookConsultationTitle: 'Reservar una Consulta',
    contactInfo: 'Información de Contacto',
    subscribeNewsletter: 'Suscríbete a Nuestro Boletín',
    newsletterDesc: 'Mantente actualizado con nuestros últimos proyectos y ofertas.',
    visitUs: 'Visítanos',
    // Services
    selectService: 'Selecciona un servicio',
    videoService: 'Producción de Video',
    postService: 'Postproducción',
    marketingService: 'Marketing y Marca',
    webService: 'Servicios Web',
    // Home Page
    welcomeTitle: 'Bienvenido a Datasignz CreativeMinds',
    welcomeSubtitle: 'Tu Socio en Excelencia Creativa',
    ourWork: 'Nuestro Trabajo',
    ourServices: 'Nuestros Servicios',
    viewPortfolio: 'Ver Portafolio',
    // Web Services Page
    webServicesTitle: 'Servicios Web por NeuralNext',
    webServicesDesc1: 'NeuralNext es una división de soluciones digitales visionaria dentro de Datasignz CreativeMinds, enfocada en construir sitios web y aplicaciones inteligentes que se adaptan, aprenden y funcionan. Como división especializada de Datasignz CreativeMinds, NeuralNext combina automatización avanzada, lógica basada en datos y diseño centrado en el ser humano para entregar plataformas que trabajan más inteligentemente y escalan más rápido.',
    webServicesDesc2: 'No solo desarrollamos productos digitales — diseñamos ecosistemas responsivos que anticipan el comportamiento del usuario, optimizan operaciones y desbloquean crecimiento medible. Desde el concepto hasta la implementación, NeuralNext transforma la complejidad en experiencias digitales fluidas construidas para el futuro.',
    webServicesDesc3: 'Un componente central de este enfoque es el despliegue estratégico de interfaces conversacionales. Los chatbots inteligentes extienden tu presencia digital más allá de la interacción estática proporcionando engagement en tiempo real, soporte al cliente automatizado y viajes de usuario guiados a escala.',
    webServicesDesc4: 'Al manejar consultas rutinarias, calificar leads e integrarse directamente con sistemas internos, los chatbots reducen la fricción operativa, mejoran los tiempos de respuesta y generan insights accionables. El resultado es mayor eficiencia, tasas de conversión más altas y una experiencia del cliente consistentemente accesible, sin agregar gastos generales.',
    webServicesCTA: 'Pruébalo tú mismo. Haz clic en el ícono blanco y negro en la esquina inferior derecha.',
    ourPortfolio: 'Nuestro Portafolio',
    // Web Services Packages
    landingPage: 'Página de Destino',
    websiteBudget: 'Sitio Web Económico',
    websiteStandard: 'Sitio Web Estándar',
    websiteElite: 'Sitio Web Elite',
    basicDesign: 'Diseño básico',
    responsiveLayout: 'Diseño responsivo',
    contactForm: 'Formulario de contacto',
    socialMediaIntegration: 'Integración de redes sociales',
    photoGallery: 'Galería de fotos',
    fourPages: '4 páginas',
    bookingsForm: 'Formulario de reservas',
    customDesign: 'Diseño personalizado según marca',
    maxTenPages: 'Máximo 10 páginas',
    photoGalleryVideo: 'Galería de fotos y enlaces de video',
    bookingQuoteForm: 'Formulario de reserva/cotización',
    maxTwentyFivePages: 'Máximo 25 páginas',
    videoHeader: 'Encabezado de Video / Encabezado Animado',
    seoTitle: 'Optimización para Motores de Búsqueda',
    searchFunction: 'Función de Búsqueda',
    whatsappChat: 'Integración de Chat WhatsApp',
    googleAnalytics: 'Google Analytics',
    aiImageVideo: 'Generación de Imagen y Video con IA',
    ecommerceSolutions: 'Soluciones de Comercio Electrónico',
    domainHosting: 'Registro de Dominio y Alojamiento',
    priceOnRequest: 'Precio bajo consulta',
    webDevProcess: 'Nuestro Proceso de Desarrollo Web',
    planning: 'Planificación',
    planningDesc: 'Definir objetivos y requisitos',
    designStep: 'Diseño',
    designStepDesc: 'UI/UX e identidad visual',
    development: 'Desarrollo',
    developmentDesc: 'Construyendo tu sitio web',
    testing: 'Pruebas',
    testingDesc: 'Control de calidad',
    launch: 'Lanzamiento',
    launchDesc: 'En vivo y soporte',
    // CTA Section
    ctaTitle: '¿Listo para dar vida a tu visión?',
    ctaSubtitle: 'Hablemos de tu proyecto y creemos algo extraordinario juntos.',
    getQuote: 'Solicitar Cotización',
    // Video Production Page
    videoProductionTitle: 'Producción de Video',
    videoProductionDesc1: 'Datasignz Creative Minds da vida a las historias a través de una producción de video con propósito y alto impacto. Creamos contenido visual que hace más que verse bien — comunica, persuade y funciona. Desde películas de marca y comerciales hasta videos corporativos y contenido digital, cada producción está estratégicamente diseñada para fortalecer tu mensaje y elevar tu marca.',
    videoProductionDesc2: 'Con una visión creativa aguda y un enfoque orientado a resultados, combinamos storytelling, cinematografía y experiencia en postproducción para entregar videos que conectan con tu audiencia y apoyan tus objetivos comerciales. Ya sea que estés lanzando una marca, promocionando un servicio o construyendo visibilidad a largo plazo, Datasignz Creative Minds convierte ideas en experiencias visuales convincentes.',
    featuredClients: 'Clientes destacados:',
    // Video Production Services
    tvCommercialsTitle: 'Comerciales de TV y Publicidad',
    tvCommercialsDesc: 'Comerciales profesionales para clientes de retail, automotriz, hospitalidad y corporativos.',
    corporateFilmsTitle: 'Películas Corporativas y Videos de Ambiente',
    corporateFilmsDesc: 'Producciones orientadas a la identidad que destacan la cultura empresarial, valores y promesa de marca.',
    musicVideosTitle: 'Videos Musicales',
    musicVideosDesc: 'Colaboraciones creativas con artistas para dar vida a su visión.',
    documentariesTitle: 'Documentales y Cortometrajes',
    documentariesDesc: 'Cubriendo temas culturales, ambientales y sociales con calidad cinematográfica.',
    promoVideosTitle: 'Videos Promocionales',
    promoVideosDesc: 'Películas promocionales para marcas, proyectos y eventos.',
    afterMoviesTitle: 'Aftermovies / Videos de Eventos',
    afterMoviesDesc: 'Videos resumen de eventos que capturan la energía y los momentos destacados.',
    readyBringVision: '¿Listo para dar vida a tu visión?',
    videoCTADesc: 'Hablemos de tu proyecto y creemos algo extraordinario juntos.',
    getQuote: 'Solicitar Cotización',
    // Post Production Page
    postProductionTitle: 'Postproducción',
    postProductionDesc1: 'Nuestros servicios de postproducción transforman el metraje en bruto en contenido pulido y profesional. Manejamos todo, desde la corrección de color y mezcla de audio hasta efectos visuales y motion graphics.',
    postProductionDesc2: 'Con suites de edición de última generación y editores experimentados, aseguramos que tu contenido cumpla con los más altos estándares de broadcast y digitales.',
    // Post Production Services
    animationsVFXTitle: 'Animaciones y Efectos Visuales',
    animationsVFXDesc: 'Motion graphics, animación 3D, transiciones dinámicas y gradación de color cinematográfica.',
    colorGradingTitle: 'Gradación de Color y Postproducción',
    colorGradingDesc: 'Servicios profesionales de gradación de color y edición para mejorar tus producciones de video.',
    socialVidzz: 'SocialVidzz',
    socialVidzzDesc: 'Animaciones dinámicas y contenido de video listo para redes sociales con transiciones cautivadoras.',
    videoTestimonials: 'Video Testimonios',
    videoTestimonialsDesc: 'Videos de testimonios profesionales con hasta 3 personas.',
    extraLanguageSupport: 'Soporte de Idioma Extra',
    extraLanguageSupportDesc: 'Agrega versiones en idiomas adicionales a tu contenido de video.',
    audioProductionTitle: 'Producción de Audio',
    audioProductionDesc: 'Mezcla de audio profesional, diseño de sonido y servicios de locución para tus proyectos de video.',
    postProductionProcess: 'Nuestro Proceso de Postproducción',
    importOrganize: 'Importar y Organizar',
    importOrganizeDesc: 'Importamos y organizamos todo el metraje sistemáticamente',
    roughCut: 'Corte Preliminar',
    roughCutDesc: 'Creando la estructura inicial de edición y flujo',
    fineEditing: 'Edición Fina',
    fineEditingDesc: 'Edición de precisión con transiciones y efectos',
    colorSound: 'Color y Sonido',
    colorSoundDesc: 'Gradación de color final y masterización de audio',
    needPostProduction: '¿Necesitas postproducción profesional?',
    postProductionCTADesc: 'Deja que nuestros expertos transformen tu metraje en contenido visual impresionante.',
    startYourProject: 'Inicia Tu Proyecto',
    // On-Air Identity Page
    onAirIdentityTitle: 'Identidad en Pantalla',
    onAirIdentityDesc1: 'Creamos identidades en pantalla distintivas que capturan la atención y construyen reconocimiento de marca. Desde branding de canales hasta empaquetado de programas, nuestros diseños hacen que tu contenido destaque.',
    onAirIdentityDesc2: 'Nuestro equipo se especializa en crear sistemas visuales cohesivos que funcionan en todas las plataformas de broadcast.',
    // On-Air Services
    channelBrandingTitle: 'Branding de Canal',
    channelBrandingDesc: 'Paquetes completos de identidad visual para canales de TV incluyendo logos, esquemas de color y guías de marca.',
    identsBumpersTitle: 'Idents y Bumpers',
    identsBumpersDesc: 'Identificaciones de estación y bumpers de programa llamativos que refuerzan el reconocimiento de marca.',
    lowerThirdsTitle: 'Lower Thirds y Gráficos',
    lowerThirdsDesc: 'Gráficos profesionales en pantalla incluyendo lower thirds, tickers y displays de información.',
    showPackagingTitle: 'Empaquetado de Shows',
    showPackagingDesc: 'Paquetes visuales completos para programas de TV incluyendo aberturas, transiciones y créditos finales.',
    motionGraphicsTitle: 'Motion Graphics',
    motionGraphicsDesc: 'Elementos animados dinámicos que dan vida a tu transmisión con impresionantes efectos visuales.',
    promoProductionTitle: 'Producción de Promos',
    promoProductionDesc: 'Contenido promocional convincente para anunciar próximos programas y eventos especiales.',
    logoDesign: 'Diseño de Logo',
    brandGuidelines: 'Guías de Marca',
    colorPalette: 'Paleta de Colores',
    typographySystem: 'Sistema de Tipografía',
    stationIdents: 'Idents de Estación',
    programBumpers: 'Bumpers de Programa',
    sponsorTags: 'Tags de Patrocinador',
    breakStings: 'Break Stings',
    lowerThirds: 'Lower Thirds',
    newsTickers: 'Tickers de Noticias',
    scoreGraphics: 'Gráficos de Puntuación',
    infoPanels: 'Paneles de Información',
    showOpeners: 'Aberturas de Show',
    transitions: 'Transiciones',
    endCredits: 'Créditos Finales',
    segmentHeaders: 'Encabezados de Segmento',
    animatedLogos: 'Logos Animados',
    titleSequences: 'Secuencias de Título',
    visualEffects: 'Efectos Visuales',
    threeDElements: 'Elementos 3D',
    showPromos: 'Promos de Shows',
    eventTeasers: 'Teasers de Eventos',
    comingUpNext: 'A Continuación',
    specialAnnouncements: 'Anuncios Especiales',
    onAirProcess: 'Nuestro Proceso de Identidad en Pantalla',
    discovery: 'Descubrimiento',
    discoveryDesc: 'Entendiendo tu marca y audiencia',
    concept: 'Concepto',
    conceptDesc: 'Dirección creativa y marcos de estilo',
    design: 'Diseño',
    designDesc: 'Desarrollo completo del paquete gráfico',
    deliveryProcess: 'Entrega',
    deliveryProcessDesc: 'Assets finales en formatos de broadcast',
    readyElevateBroadcast: '¿Listo para elevar tu identidad de broadcast?',
    onAirCTADesc: 'Creemos una presencia en pantalla distintiva que cautive a tu audiencia.',
    // Marketing & Branding Page
    marketingBrandingTitle: 'Marketing y Marca',
    marketingBrandingDesc1: 'Soluciones estratégicas de marketing y branding que ayudan a tu negocio a crecer. Desarrollamos identidades de marca integrales y campañas de marketing que resuenan con tu público objetivo.',
    marketingBrandingDesc2: 'Desde diseño de logotipos hasta estrategias de marketing completas, te ayudamos a construir una presencia de marca fuerte y memorable.',
    // Marketing Services
    emailMarketingTitle: 'Campañas de Email Marketing',
    emailMarketingDesc: 'Campañas dirigidas para construir relaciones con clientes, promocionar productos e impulsar conversiones.',
    socialMediaMarketingTitle: 'Marketing en Redes Sociales',
    socialMediaMarketingDesc: 'Contenido atractivo adaptado para Facebook, Instagram, TikTok y LinkedIn.',
    brandingTitle: 'Branding y Desarrollo de Marca',
    brandingDesc: 'Campañas estratégicas construidas alrededor de identidad, promesa y unicidad.',
    aiBotsTitle: 'Bots de IA y Automatización',
    aiBotsDesc: 'Chatbots impulsados por IA para soporte al cliente, generación de leads y marketing interactivo.',
    whyChooseMarketing: '¿Por Qué Elegir Nuestros Servicios de Marketing?',
    dataDrivenStrategy: 'Estrategia Basada en Datos',
    dataDrivenStrategyDesc: 'Usamos análisis e insights para crear campañas que entregan resultados medibles.',
    creativeExcellence: 'Excelencia Creativa',
    creativeExcellenceDesc: 'Nuestro equipo combina visión artística con experiencia en marketing para campañas destacadas.',
    fullServiceSupport: 'Soporte de Servicio Completo',
    fullServiceSupportDesc: 'Desde estrategia hasta ejecución, manejamos cada aspecto de tus necesidades de marketing.',
    readyElevateBrand: '¿Listo para elevar tu marca?',
    marketingCTADesc: 'Creemos una estrategia de marketing que impulse resultados y construya conexiones duraderas.',
    // Company Intro Section
    companyIntro1Title: 'VISIÓN CREATIVA',
    companyIntro1Content: 'En Datasignz CreativeMinds, creemos que cada marca tiene una historia única esperando ser contada. Nuestra visión creativa combina excelencia artística con pensamiento estratégico para producir contenido que resuena con tu audiencia y eleva tu identidad de marca.',
    companyIntro2Title: 'EQUIPO EXPERTO',
    companyIntro2Content: 'Nuestro equipo de profesionales capacitados reúne experiencia en producción de video, postproducción, motion graphics y marketing digital. Con años de experiencia en diversas industrias, entregamos resultados excepcionales que superan las expectativas.',
    companyIntro3Title: 'IMPULSADOS POR LA INNOVACIÓN',
    companyIntro3Content: 'Nos mantenemos a la vanguardia de la tecnología y las tendencias creativas para ofrecerte soluciones de última generación. Desde herramientas impulsadas por IA hasta las últimas técnicas de producción, aprovechamos la innovación para dar a tu marca una ventaja competitiva en el panorama digital.',
    // Portfolio Section
    ourPortfolio: 'Nuestro Portafolio',
    portfolioDesc: 'Explora nuestros proyectos recientes y descubre cómo ayudamos a las marcas a cobrar vida.',
    // Footer
    footerDesc: 'Datasignz CreativeMinds es un estudio creativo y digital de servicio completo con sede en Paramaribo que ofrece narrativa visual de alto impacto, soluciones web, campañas de marketing y herramientas impulsadas por IA que ayudan a las marcas a construir identidad, involucrar audiencias y crecer en todas las plataformas.',
    copyright: 'Copyright © 2026, Datasignz CreativeMinds. Todos los Derechos Reservados.',
    // Cookie Consent Banner
    cookieConsentTitle: 'Usamos cookies',
    cookieConsentDesc: 'Usamos cookies para mejorar tu experiencia de navegación, analizar el tráfico del sitio y personalizar el contenido. Al hacer clic en "Aceptar Todo", consientes nuestro uso de cookies.',
    cookieAcceptAll: 'Aceptar Todo',
    cookieSettings: 'Configuración',
    cookieDecline: 'Rechazar Opcionales',
    cookieSavePreferences: 'Guardar Preferencias',
    cookieAlwaysOn: 'Siempre Activo',
    // Admin Dashboard
    adminLogin: 'Inicio de Sesión Admin',
    adminLoginDesc: 'Ingresa la contraseña de administrador para acceder al panel.',
    adminPassword: 'Contraseña',
    adminLoginBtn: 'Iniciar Sesión',
    adminBackToSite: 'Volver al Sitio Web',
    adminWrongPassword: 'Contraseña incorrecta. Por favor intenta de nuevo.',
    adminDashboard: 'Panel de Administración',
    adminRefresh: 'Actualizar',
    adminLogout: 'Cerrar Sesión',
    adminContactSubmissions: 'Envíos de Contacto',
    adminBookingRequests: 'Solicitudes de Reserva',
    adminNewsletterSubs: 'Suscriptores del Boletín',
    adminContacts: 'Contactos',
    adminBookings: 'Reservas',
    adminSubscribers: 'Suscriptores',
    adminNoContacts: 'Aún no hay envíos de contacto.',
    adminNoBookings: 'Aún no hay solicitudes de reserva.',
    adminNoSubscribers: 'Aún no hay suscriptores del boletín.',
    adminDate: 'Fecha',
    adminSubmittedAt: 'Enviado El',
    adminSubscribedAt: 'Suscrito El',
    // Legal Pages - Privacy Policy
    privacyPolicyTitle: 'Política de Privacidad',
    lastUpdated: 'Última actualización:',
    january2025: 'Enero 2025',
    privacyIntroTitle: '1. Introducción',
    privacyIntroContent: 'Datasignz CreativeMinds ("nosotros," "nuestro," o "nos") respeta su privacidad y está comprometido a proteger sus datos personales. Esta política de privacidad explica cómo recopilamos, usamos y protegemos su información cuando visita nuestro sitio web o utiliza nuestros servicios.',
    privacyCollectTitle: '2. Información que recopilamos',
    privacyCollectIntro: 'Podemos recopilar los siguientes tipos de información:',
    privacyCollectPersonal: 'Información Personal:',
    privacyCollectPersonalDesc: 'Nombre, dirección de correo electrónico, número de teléfono y otros datos de contacto que proporciona a través de nuestros formularios.',
    privacyCollectUsage: 'Datos de Uso:',
    privacyCollectUsageDesc: 'Información sobre cómo utiliza nuestro sitio web, incluyendo páginas visitadas, tiempo invertido y patrones de navegación.',
    privacyCollectTechnical: 'Datos Técnicos:',
    privacyCollectTechnicalDesc: 'Dirección IP, tipo de navegador, información del dispositivo y sistema operativo.',
    privacyUseTitle: '3. Cómo usamos su información',
    privacyUseIntro: 'Usamos su información para:',
    privacyUse1: 'Responder a sus consultas y proporcionar atención al cliente',
    privacyUse2: 'Procesar solicitudes de reserva y consultas',
    privacyUse3: 'Enviar boletines y comunicaciones de marketing (con su consentimiento)',
    privacyUse4: 'Mejorar nuestro sitio web y servicios',
    privacyUse5: 'Cumplir con obligaciones legales',
    privacySharingTitle: '4. Compartir datos',
    privacySharingContent: 'No vendemos su información personal. Podemos compartir sus datos con proveedores de servicios externos de confianza que nos ayudan a operar nuestro sitio web y realizar nuestro negocio, sujeto a acuerdos de confidencialidad.',
    privacySecurityTitle: '5. Seguridad de datos',
    privacySecurityContent: 'Implementamos medidas técnicas y organizativas apropiadas para proteger sus datos personales contra acceso no autorizado, alteración, divulgación o destrucción.',
    privacyRightsTitle: '6. Sus derechos',
    privacyRightsIntro: 'Tiene derecho a:',
    privacyRights1: 'Acceder a sus datos personales',
    privacyRights2: 'Corregir datos inexactos',
    privacyRights3: 'Solicitar la eliminación de sus datos',
    privacyRights4: 'Oponerse al procesamiento de sus datos',
    privacyRights5: 'Retirar el consentimiento en cualquier momento',
    privacyContactTitle: '7. Contáctenos',
    privacyContactIntro: 'Si tiene alguna pregunta sobre esta Política de Privacidad, contáctenos en:',
    // Legal Pages - Terms of Service
    termsTitle: 'Términos de Servicio',
    termsAcceptTitle: '1. Aceptación de términos',
    termsAcceptContent: 'Al acceder y utilizar el sitio web y los servicios de Datasignz CreativeMinds, acepta y acuerda estar sujeto a estos Términos de Servicio. Si no está de acuerdo con estos términos, por favor no utilice nuestros servicios.',
    termsServicesTitle: '2. Servicios',
    termsServicesContent: 'Datasignz CreativeMinds proporciona producción de video, postproducción, identidad en pantalla, marketing y marca, y servicios web. Los términos específicos para cada proyecto se detallarán en acuerdos de proyecto individuales.',
    termsIPTitle: '3. Propiedad intelectual',
    termsIPContent: 'Todo el contenido de este sitio web, incluyendo texto, gráficos, logotipos, imágenes y software, es propiedad de Datasignz CreativeMinds y está protegido por derechos de autor y otras leyes de propiedad intelectual. No puede reproducir, distribuir o crear obras derivadas sin nuestro permiso escrito expreso.',
    termsUserTitle: '4. Responsabilidades del usuario',
    termsUserIntro: 'Usted acepta:',
    termsUser1: 'Proporcionar información precisa al usar nuestros servicios',
    termsUser2: 'No usar nuestros servicios para ningún propósito ilegal',
    termsUser3: 'No interferir con el funcionamiento adecuado de nuestro sitio web',
    termsUser4: 'Respetar los derechos de propiedad intelectual de otros',
    termsPaymentTitle: '5. Términos de pago',
    termsPaymentContent: 'Los términos de pago para los servicios se especificarán en acuerdos de proyecto individuales. A menos que se acuerde lo contrario, los pagos vencen dentro de los 30 días posteriores a la fecha de factura.',
    termsLiabilityTitle: '6. Limitación de responsabilidad',
    termsLiabilityContent: 'Datasignz CreativeMinds no será responsable de ningún daño indirecto, incidental, especial, consecuente o punitivo que surja de su uso de nuestros servicios o sitio web.',
    termsTerminationTitle: '7. Terminación',
    termsTerminationContent: 'Nos reservamos el derecho de terminar o suspender el acceso a nuestros servicios en cualquier momento, sin previo aviso, por conducta que creamos que viola estos Términos de Servicio o es perjudicial para otros usuarios.',
    termsGoverningTitle: '8. Ley aplicable',
    termsGoverningContent: 'Estos Términos de Servicio se regirán e interpretarán de acuerdo con las leyes de Surinam.',
    termsContactTitle: '9. Contacto',
    termsContactContent: 'Para preguntas sobre estos Términos de Servicio, contáctenos en brian@datasignz.nl.',
    // Legal Pages - Cookie Policy
    cookieTitle: 'Política de Cookies',
    cookieWhatTitle: '1. Qué son las cookies',
    cookieWhatContent: 'Las cookies son pequeños archivos de texto que se colocan en su computadora o dispositivo móvil cuando visita un sitio web. Se utilizan ampliamente para hacer que los sitios web funcionen de manera más eficiente y proporcionar información a los propietarios del sitio.',
    cookieHowTitle: '2. Cómo usamos las cookies',
    cookieHowIntro: 'Usamos cookies para los siguientes propósitos:',
    cookieEssential: 'Cookies Esenciales:',
    cookieEssentialDesc: 'Necesarias para que el sitio web funcione correctamente',
    cookieAnalytics: 'Cookies de Análisis:',
    cookieAnalyticsDesc: 'Nos ayudan a entender cómo los visitantes interactúan con nuestro sitio',
    cookieFunctional: 'Cookies Funcionales:',
    cookieFunctionalDesc: 'Recuerdan sus preferencias y configuraciones',
    cookieMarketing: 'Cookies de Marketing:',
    cookieMarketingDesc: 'Usadas para mostrar anuncios relevantes',
    cookieTypesTitle: '3. Tipos de cookies que usamos',
    cookieEssentialTitle: 'Cookies Esenciales',
    cookieEssentialContent: 'Estas cookies son necesarias para que el sitio web funcione y no se pueden desactivar. Generalmente se establecen en respuesta a acciones que realiza, como configurar sus preferencias de privacidad o completar formularios.',
    cookieAnalyticsTitle: 'Cookies de Análisis',
    cookieAnalyticsContent: 'Utilizamos servicios de análisis para ayudarnos a entender cómo se utiliza nuestro sitio web. Estas cookies recopilan información sobre su uso del sitio, como qué páginas visita con más frecuencia.',
    cookieThirdPartyTitle: 'Cookies de Terceros',
    cookieThirdPartyContent: 'Algunas cookies son colocadas por servicios de terceros que aparecen en nuestras páginas, como videos incrustados de YouTube o botones de compartir en redes sociales.',
    cookieManagingTitle: '4. Gestión de cookies',
    cookieManagingContent: 'La mayoría de los navegadores web le permiten controlar las cookies a través de su configuración. Puede configurar su navegador para rechazar cookies o eliminar ciertas cookies. Sin embargo, si bloquea o elimina cookies, algunas funciones de nuestro sitio web pueden no funcionar correctamente.',
    cookieBrowserTitle: '5. Configuración del navegador',
    cookieBrowserIntro: 'Puede gestionar las cookies en la configuración de su navegador:',
    cookieUpdatesTitle: '6. Actualizaciones de esta política',
    cookieUpdatesContent: 'Podemos actualizar esta Política de Cookies de vez en cuando. Cualquier cambio se publicará en esta página con una fecha de revisión actualizada.',
    cookieContactTitle: '7. Contáctenos',
    cookieContactContent: 'Si tiene preguntas sobre nuestro uso de cookies, contáctenos en brian@datasignz.nl.',
    // Legal Pages - Disclaimer
    disclaimerTitle: 'Aviso Legal',
    disclaimerGeneralTitle: '1. Información general',
    disclaimerGeneralContent: 'La información proporcionada en este sitio web es solo para fines informativos generales. Aunque nos esforzamos por mantener la información actualizada y precisa, Datasignz CreativeMinds no hace representaciones ni garantías de ningún tipo, expresas o implícitas, sobre la integridad, exactitud, confiabilidad, idoneidad o disponibilidad del sitio web o la información, productos, servicios o gráficos relacionados contenidos en el sitio web.',
    disclaimerAdviceTitle: '2. Asesoramiento profesional',
    disclaimerAdviceContent: 'El contenido de este sitio web no pretende sustituir el asesoramiento profesional. Siempre busque el consejo de profesionales calificados para cualquier pregunta que pueda tener sobre servicios o proyectos específicos.',
    disclaimerLinksTitle: '3. Enlaces externos',
    disclaimerLinksContent: 'Este sitio web puede contener enlaces a sitios web externos que no son proporcionados ni mantenidos por Datasignz CreativeMinds. No garantizamos la exactitud, relevancia, oportunidad o integridad de la información en estos sitios web externos.',
    disclaimerLiabilityTitle: '4. Limitación de responsabilidad',
    disclaimerLiabilityContent: 'En ningún caso Datasignz CreativeMinds será responsable de ninguna pérdida o daño, incluyendo sin limitación, pérdida o daño indirecto o consecuente, o cualquier pérdida o daño que surja de la pérdida de datos o ganancias derivadas de o en conexión con el uso de este sitio web.',
    disclaimerPortfolioTitle: '5. Portfolio y trabajo de muestra',
    disclaimerPortfolioContent: 'Los elementos del portfolio y el trabajo de muestra mostrados en este sitio web son solo para fines de demostración. Los resultados pueden variar dependiendo de los requisitos, especificaciones y circunstancias individuales del proyecto.',
    disclaimerAvailabilityTitle: '6. Disponibilidad',
    disclaimerAvailabilityContent: 'No garantizamos que el sitio web esté disponible en todo momento. Podemos experimentar problemas de hardware, software u otros, o necesitar realizar mantenimiento relacionado con el sitio web, lo que puede resultar en interrupciones, retrasos o errores.',
    disclaimerChangesTitle: '7. Cambios',
    disclaimerChangesContent: 'Datasignz CreativeMinds se reserva el derecho de realizar cambios en este aviso legal en cualquier momento. Su uso continuado del sitio web después de la publicación de cambios constituye su aceptación de esos cambios.',
    disclaimerContactTitle: '8. Contacto',
    disclaimerContactIntro: 'Si tiene alguna pregunta sobre este Aviso Legal, contáctenos en:',
  },
  fr: {
    // Navigation
    home: 'ACCUEIL',
    videoProduction: 'PRODUCTION VIDÉO',
    postProduction: 'POST-PRODUCTION',
    onAirIdentity: 'IDENTITÉ À L\'ANTENNE',
    marketingBranding: 'MARKETING ET MARQUE',
    webServices: 'SERVICES WEB',
    contact: 'CONTACT',
    search: 'Rechercher...',
    // Footer
    privacyPolicy: 'Politique de confidentialité',
    termsOfService: 'Conditions d\'utilisation',
    cookiePolicy: 'Politique des cookies',
    disclaimer: 'Avertissement',
    allRightsReserved: 'Tous droits réservés',
    // Common
    getStarted: 'Commencer',
    learnMore: 'En savoir plus',
    sendMessage: 'Envoyer le message',
    bookConsultation: 'Réserver une consultation',
    subscribe: 'S\'abonner',
    sitemap: 'Plan du site',
    legal: 'Mentions légales',
    mostPopular: 'PLUS POPULAIRE',
    delivery: 'Livraison',
    days: 'jours',
    additionalOptions: 'Options Supplémentaires',
    webCtaTitle: 'Commencez dès aujourd\'hui à construire votre site web plus intelligemment',
    webCtaButton: 'Réserver une Consultation',
    // Extra Options
    extraVideoHeader: 'En-tête Vidéo / En-tête Animé',
    extraVideoHeaderPrice: 'USD 50',
    extraSEO: 'Optimisation pour les Moteurs de Recherche',
    extraSEOPrice: 'USD 50',
    extraWhatsApp: 'Chat WhatsApp',
    extraWhatsAppPrice: 'USD 50',
    extraChatBot: 'Chatbot Service Client (IA)',
    extraChatBotPrice: 'USD 500',
    extraTVCommercial: 'Publicité TV Budget',
    extraTVCommercialPrice: 'USD 250 - 30s | USD 450 - 60s',
    extraLanguage: 'Langue Supplémentaire',
    extraLanguagePrice: 'USD 50 par langue',
    extraDomain: 'Enregistrement de Nom de Domaine',
    extraDomainPrice: 'Prix sur demande',
    extraEcommerce: 'Solutions E-commerce',
    extraEcommercePrice: 'Prix sur demande',
    extraTestimonials: 'Témoignages Vidéo (3 personnes)',
    extraTestimonialsPrice: 'USD 100',
    extraPhotography: 'Photographie sur Site',
    extraPhotographyPrice: 'USD 150',
    extraSearch: 'Fonction de Recherche',
    extraSearchPrice: 'USD 50',
    extraAnalytics: 'Google Analytics',
    extraAnalyticsPrice: 'USD 25',
    extraAIGeneration: 'Génération d\'Images et Vidéos par IA',
    extraAIGenerationPrice: 'USD 50',
    // Portfolio Grid
    portfolioProductionSetup: 'Configuration de Production',
    portfolioProfessionalLighting: 'Éclairage Professionnel',
    portfolioCinematographer: 'Directeur Photo',
    portfolioCameraSetup: 'Configuration Caméra',
    portfolioPostProduction: 'Post-production',
    portfolioFX6Camera: 'Caméra Cinéma FX6',
    // Hero Slider
    heroSlide1Name: 'TBL Cinemas',
    heroSlide1Desc: 'Promo d\'identité de marque avec slogan et versions courtes pour les réseaux sociaux',
    heroSlide2Name: 'Datasignz CreativeMinds Showreel',
    heroSlide2Desc: '',
    heroSlide3Name: 'Akira Overwater Resort',
    heroSlide3Desc: 'Vidéo promotionnelle',
    heroSlide4Name: 'Birdland Suriname',
    heroSlide4Desc: 'Coq-de-roche',
    heroSlide5Name: 'Documentaire BBC',
    heroSlide5Desc: 'Comment l\'Amazonie est devenue un refuge pour les Africains réduits en esclavage',
    // Contact Page
    contactUs: 'Contactez-nous',
    getInTouch: 'Nous Contacter',
    sendUsMessage: 'Envoyez-nous un Message',
    name: 'Nom',
    email: 'E-mail',
    phone: 'Téléphone',
    subject: 'Sujet',
    message: 'Message',
    service: 'Service',
    preferredDate: 'Date préférée',
    additionalNotes: 'Notes supplémentaires',
    pickDate: 'Choisir une date',
    sending: 'Envoi en cours...',
    booking: 'Réservation en cours...',
    contactSubtitle: 'Prêt à donner vie à votre vision ? Nous serions ravis de vous entendre.',
    bookConsultationTitle: 'Réserver une Consultation',
    contactInfo: 'Coordonnées',
    subscribeNewsletter: 'Abonnez-vous à Notre Newsletter',
    newsletterDesc: 'Restez informé de nos derniers projets et offres.',
    visitUs: 'Visitez-nous',
    // Services
    selectService: 'Sélectionnez un service',
    videoService: 'Production Vidéo',
    postService: 'Post-production',
    marketingService: 'Marketing et Marque',
    webService: 'Services Web',
    // Home Page
    welcomeTitle: 'Bienvenue chez Datasignz CreativeMinds',
    welcomeSubtitle: 'Votre Partenaire en Excellence Créative',
    ourWork: 'Notre Travail',
    ourServices: 'Nos Services',
    viewPortfolio: 'Voir le Portfolio',
    // Web Services Page
    webServicesTitle: 'Services Web par NeuralNext',
    webServicesDesc1: 'NeuralNext est une division de solutions numériques avant-gardiste au sein de Datasignz CreativeMinds, axée sur la création de sites web et d\'applications intelligents qui s\'adaptent, apprennent et performent. En tant que division spécialisée de Datasignz CreativeMinds, NeuralNext allie automatisation avancée, logique basée sur les données et design centré sur l\'humain pour fournir des plateformes qui fonctionnent plus intelligemment et évoluent plus rapidement.',
    webServicesDesc2: 'Nous ne développons pas seulement des produits numériques — nous concevons des écosystèmes réactifs qui anticipent le comportement des utilisateurs, rationalisent les opérations et débloquent une croissance mesurable. Du concept au déploiement, NeuralNext transforme la complexité en expériences numériques fluides construites pour l\'avenir.',
    webServicesDesc3: 'Un composant central de cette approche est le déploiement stratégique d\'interfaces conversationnelles. Les chatbots intelligents étendent votre présence numérique au-delà de l\'interaction statique en fournissant un engagement en temps réel, un support client automatisé et des parcours utilisateurs guidés à grande échelle.',
    webServicesDesc4: 'En gérant les demandes de routine, en qualifiant les leads et en s\'intégrant directement aux systèmes internes, les chatbots réduisent les frictions opérationnelles, améliorent les temps de réponse et génèrent des insights exploitables. Le résultat est une efficacité accrue, des taux de conversion plus élevés et une expérience client constamment accessible, sans ajouter de frais généraux.',
    webServicesCTA: 'Essayez-le vous-même. Cliquez sur l\'icône noir et blanc dans le coin inférieur droit.',
    ourPortfolio: 'Notre Portfolio',
    // Web Services Packages
    landingPage: 'Page d\'Atterrissage',
    websiteBudget: 'Site Web Budget',
    websiteStandard: 'Site Web Standard',
    websiteElite: 'Site Web Elite',
    basicDesign: 'Design de base',
    responsiveLayout: 'Mise en page responsive',
    contactForm: 'Formulaire de contact',
    socialMediaIntegration: 'Intégration des réseaux sociaux',
    photoGallery: 'Galerie photos',
    fourPages: '4 pages',
    bookingsForm: 'Formulaire de réservation',
    customDesign: 'Design personnalisé selon l\'image de marque',
    maxTenPages: 'Maximum 10 pages',
    photoGalleryVideo: 'Galerie photos et liens vidéo',
    bookingQuoteForm: 'Formulaire de réservation/devis',
    maxTwentyFivePages: 'Maximum 25 pages',
    videoHeader: 'En-tête Vidéo / En-tête Animé',
    seoTitle: 'Optimisation pour les Moteurs de Recherche',
    searchFunction: 'Fonction de Recherche',
    whatsappChat: 'Intégration Chat WhatsApp',
    googleAnalytics: 'Google Analytics',
    aiImageVideo: 'Génération d\'Images et Vidéos par IA',
    ecommerceSolutions: 'Solutions E-commerce',
    domainHosting: 'Enregistrement de Domaine et Hébergement',
    priceOnRequest: 'Prix sur demande',
    webDevProcess: 'Notre Processus de Développement Web',
    planning: 'Planification',
    planningDesc: 'Définir les objectifs et exigences',
    designStep: 'Conception',
    designStepDesc: 'UI/UX et identité visuelle',
    development: 'Développement',
    developmentDesc: 'Construction de votre site web',
    testing: 'Tests',
    testingDesc: 'Assurance qualité',
    launch: 'Lancement',
    launchDesc: 'Mise en ligne et support',
    // CTA Section
    ctaTitle: 'Prêt à donner vie à votre vision ?',
    ctaSubtitle: 'Discutons de votre projet et créons ensemble quelque chose d\'extraordinaire.',
    getQuote: 'Demander un Devis',
    // Video Production Page
    videoProductionTitle: 'Production Vidéo',
    videoProductionDesc1: 'Datasignz Creative Minds donne vie aux histoires grâce à une production vidéo ciblée et à fort impact. Nous créons du contenu visuel qui fait plus que bien paraître — il communique, persuade et performe. Des films de marque et publicités aux vidéos d\'entreprise et contenus numériques, chaque production est stratégiquement conçue pour renforcer votre message et élever votre marque.',
    videoProductionDesc2: 'Avec une vision créative aiguisée et une approche axée sur les résultats, nous combinons storytelling, cinématographie et expertise en post-production pour livrer des vidéos qui connectent avec votre audience et soutiennent vos objectifs commerciaux. Que vous lanciez une marque, promouviez un service ou construisiez une visibilité à long terme, Datasignz Creative Minds transforme les idées en expériences visuelles convaincantes.',
    featuredClients: 'Clients en vedette :',
    // Video Production Services
    tvCommercialsTitle: 'Publicités TV et Spots',
    tvCommercialsDesc: 'Publicités professionnelles pour les clients du retail, de l\'automobile, de l\'hôtellerie et des entreprises.',
    corporateFilmsTitle: 'Films d\'Entreprise et Vidéos d\'Ambiance',
    corporateFilmsDesc: 'Productions axées sur l\'identité qui mettent en valeur la culture d\'entreprise, les valeurs et la promesse de marque.',
    musicVideosTitle: 'Clips Musicaux',
    musicVideosDesc: 'Collaborations créatives avec des artistes pour donner vie à leur vision.',
    documentariesTitle: 'Documentaires et Courts Métrages',
    documentariesDesc: 'Couvrant des thèmes culturels, environnementaux et sociaux avec une qualité cinématographique.',
    promoVideosTitle: 'Vidéos Promotionnelles',
    promoVideosDesc: 'Films promotionnels pour les marques, projets et événements.',
    afterMoviesTitle: 'Aftermovies / Vidéos d\'Événements',
    afterMoviesDesc: 'Vidéos récapitulatives d\'événements qui capturent l\'énergie et les moments forts.',
    readyBringVision: 'Prêt à donner vie à votre vision ?',
    videoCTADesc: 'Discutons de votre projet et créons ensemble quelque chose d\'extraordinaire.',
    getQuote: 'Demander un Devis',
    // Post Production Page
    postProductionTitle: 'Post-production',
    postProductionDesc1: 'Nos services de post-production transforment les rushes en contenu soigné et professionnel. Nous gérons tout, de l\'étalonnage des couleurs et du mixage audio aux effets visuels et au motion design.',
    postProductionDesc2: 'Avec des suites de montage à la pointe de la technologie et des monteurs expérimentés, nous garantissons que votre contenu répond aux plus hauts standards de diffusion et numériques.',
    // Post Production Services
    animationsVFXTitle: 'Animations et Effets Visuels',
    animationsVFXDesc: 'Motion graphics, animation 3D, transitions dynamiques et étalonnage couleur cinématographique.',
    colorGradingTitle: 'Étalonnage Couleur et Post-production',
    colorGradingDesc: 'Services professionnels d\'étalonnage couleur et de montage pour améliorer vos productions vidéo.',
    socialVidzz: 'SocialVidzz',
    socialVidzzDesc: 'Animations dynamiques et contenus vidéo prêts pour les réseaux sociaux avec des transitions captivantes.',
    videoTestimonials: 'Vidéos Témoignages',
    videoTestimonialsDesc: 'Vidéos de témoignages professionnels avec jusqu\'à 3 personnes.',
    extraLanguageSupport: 'Support Langue Supplémentaire',
    extraLanguageSupportDesc: 'Ajoutez des versions dans d\'autres langues à votre contenu vidéo.',
    audioProductionTitle: 'Production Audio',
    audioProductionDesc: 'Mixage audio professionnel, conception sonore et services de voix off pour vos projets vidéo.',
    postProductionProcess: 'Notre Processus de Post-production',
    importOrganize: 'Importer et Organiser',
    importOrganizeDesc: 'Nous importons et organisons tous les rushes systématiquement',
    roughCut: 'Premier Montage',
    roughCutDesc: 'Création de la structure initiale du montage et du flux',
    fineEditing: 'Montage Fin',
    fineEditingDesc: 'Montage de précision avec transitions et effets',
    colorSound: 'Couleur et Son',
    colorSoundDesc: 'Étalonnage couleur final et mastering audio',
    needPostProduction: 'Besoin de post-production professionnelle ?',
    postProductionCTADesc: 'Laissez nos experts transformer vos rushes en contenu visuel époustouflant.',
    startYourProject: 'Démarrez Votre Projet',
    // On-Air Identity Page
    onAirIdentityTitle: 'Identité à l\'Antenne',
    onAirIdentityDesc1: 'Nous créons des identités à l\'antenne distinctives qui captent l\'attention et construisent la reconnaissance de marque. Du branding de chaîne au packaging de programmes, nos designs font ressortir votre contenu.',
    onAirIdentityDesc2: 'Notre équipe se spécialise dans la création de systèmes visuels cohérents qui fonctionnent sur toutes les plateformes de diffusion.',
    // On-Air Services
    channelBrandingTitle: 'Branding de Chaîne',
    channelBrandingDesc: 'Packages complets d\'identité visuelle pour les chaînes TV incluant logos, palettes de couleurs et guides de marque.',
    identsBumpersTitle: 'Idents et Bumpers',
    identsBumpersDesc: 'Identifications de chaîne et bumpers de programmes accrocheurs qui renforcent la reconnaissance de marque.',
    lowerThirdsTitle: 'Lower Thirds et Graphiques',
    lowerThirdsDesc: 'Graphiques professionnels à l\'écran incluant lower thirds, tickers et affichages d\'information.',
    showPackagingTitle: 'Packaging d\'Émissions',
    showPackagingDesc: 'Packages visuels complets pour les émissions TV incluant génériques d\'ouverture, transitions et génériques de fin.',
    motionGraphicsTitle: 'Motion Graphics',
    motionGraphicsDesc: 'Éléments animés dynamiques qui donnent vie à votre diffusion avec des effets visuels époustouflants.',
    promoProductionTitle: 'Production de Promos',
    promoProductionDesc: 'Contenu promotionnel convaincant pour annoncer les prochains programmes et événements spéciaux.',
    logoDesign: 'Design de Logo',
    brandGuidelines: 'Guides de Marque',
    colorPalette: 'Palette de Couleurs',
    typographySystem: 'Système Typographique',
    stationIdents: 'Idents de Chaîne',
    programBumpers: 'Bumpers de Programme',
    sponsorTags: 'Tags Sponsors',
    breakStings: 'Break Stings',
    lowerThirds: 'Lower Thirds',
    newsTickers: 'Tickers d\'Actualités',
    scoreGraphics: 'Graphiques de Score',
    infoPanels: 'Panneaux d\'Information',
    showOpeners: 'Génériques d\'Ouverture',
    transitions: 'Transitions',
    endCredits: 'Génériques de Fin',
    segmentHeaders: 'En-têtes de Segment',
    animatedLogos: 'Logos Animés',
    titleSequences: 'Séquences de Titre',
    visualEffects: 'Effets Visuels',
    threeDElements: 'Éléments 3D',
    showPromos: 'Promos d\'Émissions',
    eventTeasers: 'Teasers d\'Événements',
    comingUpNext: 'À Suivre',
    specialAnnouncements: 'Annonces Spéciales',
    onAirProcess: 'Notre Processus d\'Identité à l\'Antenne',
    discovery: 'Découverte',
    discoveryDesc: 'Comprendre votre marque et votre audience',
    concept: 'Concept',
    conceptDesc: 'Direction créative et cadres de style',
    design: 'Design',
    designDesc: 'Développement complet du package graphique',
    deliveryProcess: 'Livraison',
    deliveryProcessDesc: 'Assets finaux aux formats de diffusion',
    readyElevateBroadcast: 'Prêt à élever votre identité de diffusion ?',
    onAirCTADesc: 'Créons une présence à l\'antenne distinctive qui captive votre audience.',
    // Marketing & Branding Page
    marketingBrandingTitle: 'Marketing et Marque',
    marketingBrandingDesc1: 'Des solutions stratégiques de marketing et de branding qui aident votre entreprise à se développer. Nous développons des identités de marque complètes et des campagnes marketing qui résonnent avec votre public cible.',
    marketingBrandingDesc2: 'De la conception de logo aux stratégies marketing complètes, nous vous aidons à construire une présence de marque forte et mémorable.',
    // Marketing Services
    emailMarketingTitle: 'Campagnes d\'Email Marketing',
    emailMarketingDesc: 'Campagnes ciblées pour construire des relations clients, promouvoir des produits et générer des conversions.',
    socialMediaMarketingTitle: 'Marketing sur les Réseaux Sociaux',
    socialMediaMarketingDesc: 'Contenu engageant adapté pour Facebook, Instagram, TikTok et LinkedIn.',
    brandingTitle: 'Branding et Développement de Marque',
    brandingDesc: 'Campagnes stratégiques construites autour de l\'identité, de la promesse et de l\'unicité.',
    aiBotsTitle: 'Bots IA et Automatisation',
    aiBotsDesc: 'Chatbots alimentés par l\'IA pour le support client, la génération de leads et le marketing interactif.',
    whyChooseMarketing: 'Pourquoi Choisir Nos Services Marketing ?',
    dataDrivenStrategy: 'Stratégie Basée sur les Données',
    dataDrivenStrategyDesc: 'Nous utilisons l\'analyse et les insights pour créer des campagnes qui livrent des résultats mesurables.',
    creativeExcellence: 'Excellence Créative',
    creativeExcellenceDesc: 'Notre équipe combine vision artistique et expertise marketing pour des campagnes remarquables.',
    fullServiceSupport: 'Support Service Complet',
    fullServiceSupportDesc: 'De la stratégie à l\'exécution, nous gérons chaque aspect de vos besoins marketing.',
    readyElevateBrand: 'Prêt à élever votre marque ?',
    marketingCTADesc: 'Créons une stratégie marketing qui génère des résultats et construit des connexions durables.',
    // Company Intro Section
    companyIntro1Title: 'VISION CRÉATIVE',
    companyIntro1Content: 'Chez Datasignz CreativeMinds, nous croyons que chaque marque a une histoire unique qui attend d\'être racontée. Notre vision créative combine excellence artistique et réflexion stratégique pour produire du contenu qui résonne avec votre audience et élève votre identité de marque.',
    companyIntro2Title: 'ÉQUIPE EXPERTE',
    companyIntro2Content: 'Notre équipe de professionnels qualifiés réunit une expertise en production vidéo, post-production, motion design et marketing digital. Avec des années d\'expérience dans diverses industries, nous livrons des résultats exceptionnels qui dépassent les attentes.',
    companyIntro3Title: 'PORTÉ PAR L\'INNOVATION',
    companyIntro3Content: 'Nous restons à la pointe de la technologie et des tendances créatives pour vous apporter des solutions de pointe. Des outils alimentés par l\'IA aux dernières techniques de production, nous exploitons l\'innovation pour donner à votre marque un avantage compétitif dans le paysage numérique.',
    // Portfolio Section
    ourPortfolio: 'Notre Portfolio',
    portfolioDesc: 'Explorez nos projets récents et découvrez comment nous aidons les marques à prendre vie.',
    // Footer
    footerDesc: 'Datasignz CreativeMinds est un studio créatif et numérique à service complet basé à Paramaribo, offrant une narration visuelle à fort impact, des solutions web, des campagnes marketing et des outils alimentés par l\'IA qui aident les marques à construire leur identité, engager leurs audiences et croître sur toutes les plateformes.',
    copyright: 'Copyright © 2026, Datasignz CreativeMinds. Tous Droits Réservés.',
    // Cookie Consent Banner
    cookieConsentTitle: 'Nous utilisons des cookies',
    cookieConsentDesc: 'Nous utilisons des cookies pour améliorer votre expérience de navigation, analyser le trafic du site et personnaliser le contenu. En cliquant sur "Tout Accepter", vous consentez à notre utilisation des cookies.',
    cookieAcceptAll: 'Tout Accepter',
    cookieSettings: 'Paramètres',
    cookieDecline: 'Refuser les Optionnels',
    cookieSavePreferences: 'Enregistrer les Préférences',
    cookieAlwaysOn: 'Toujours Actif',
    // Admin Dashboard
    adminLogin: 'Connexion Admin',
    adminLoginDesc: 'Entrez le mot de passe administrateur pour accéder au tableau de bord.',
    adminPassword: 'Mot de passe',
    adminLoginBtn: 'Se Connecter',
    adminBackToSite: 'Retour au Site',
    adminWrongPassword: 'Mot de passe incorrect. Veuillez réessayer.',
    adminDashboard: 'Tableau de Bord Admin',
    adminRefresh: 'Actualiser',
    adminLogout: 'Déconnexion',
    adminContactSubmissions: 'Soumissions de Contact',
    adminBookingRequests: 'Demandes de Réservation',
    adminNewsletterSubs: 'Abonnés Newsletter',
    adminContacts: 'Contacts',
    adminBookings: 'Réservations',
    adminSubscribers: 'Abonnés',
    adminNoContacts: 'Aucune soumission de contact pour le moment.',
    adminNoBookings: 'Aucune demande de réservation pour le moment.',
    adminNoSubscribers: 'Aucun abonné à la newsletter pour le moment.',
    adminDate: 'Date',
    adminSubmittedAt: 'Soumis Le',
    adminSubscribedAt: 'Abonné Le',
    // Legal Pages - Privacy Policy
    privacyPolicyTitle: 'Politique de Confidentialité',
    lastUpdated: 'Dernière mise à jour :',
    january2025: 'Janvier 2025',
    privacyIntroTitle: '1. Introduction',
    privacyIntroContent: 'Datasignz CreativeMinds ("nous," "notre," ou "nos") respecte votre vie privée et s\'engage à protéger vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations lorsque vous visitez notre site web ou utilisez nos services.',
    privacyCollectTitle: '2. Informations que nous collectons',
    privacyCollectIntro: 'Nous pouvons collecter les types d\'informations suivants :',
    privacyCollectPersonal: 'Informations Personnelles :',
    privacyCollectPersonalDesc: 'Nom, adresse e-mail, numéro de téléphone et autres coordonnées que vous fournissez via nos formulaires.',
    privacyCollectUsage: 'Données d\'Utilisation :',
    privacyCollectUsageDesc: 'Informations sur la façon dont vous utilisez notre site web, y compris les pages visitées, le temps passé et les modèles de navigation.',
    privacyCollectTechnical: 'Données Techniques :',
    privacyCollectTechnicalDesc: 'Adresse IP, type de navigateur, informations sur l\'appareil et système d\'exploitation.',
    privacyUseTitle: '3. Comment nous utilisons vos informations',
    privacyUseIntro: 'Nous utilisons vos informations pour :',
    privacyUse1: 'Répondre à vos demandes et fournir un support client',
    privacyUse2: 'Traiter les demandes de réservation et les consultations',
    privacyUse3: 'Envoyer des newsletters et des communications marketing (avec votre consentement)',
    privacyUse4: 'Améliorer notre site web et nos services',
    privacyUse5: 'Respecter les obligations légales',
    privacySharingTitle: '4. Partage des données',
    privacySharingContent: 'Nous ne vendons pas vos informations personnelles. Nous pouvons partager vos données avec des prestataires de services tiers de confiance qui nous aident à exploiter notre site web et à mener nos activités, sous réserve d\'accords de confidentialité.',
    privacySecurityTitle: '5. Sécurité des données',
    privacySecurityContent: 'Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre l\'accès non autorisé, la modification, la divulgation ou la destruction.',
    privacyRightsTitle: '6. Vos droits',
    privacyRightsIntro: 'Vous avez le droit de :',
    privacyRights1: 'Accéder à vos données personnelles',
    privacyRights2: 'Corriger les données inexactes',
    privacyRights3: 'Demander la suppression de vos données',
    privacyRights4: 'Vous opposer au traitement de vos données',
    privacyRights5: 'Retirer votre consentement à tout moment',
    privacyContactTitle: '7. Nous contacter',
    privacyContactIntro: 'Si vous avez des questions concernant cette Politique de Confidentialité, veuillez nous contacter à :',
    // Legal Pages - Terms of Service
    termsTitle: 'Conditions d\'Utilisation',
    termsAcceptTitle: '1. Acceptation des conditions',
    termsAcceptContent: 'En accédant et en utilisant le site web et les services de Datasignz CreativeMinds, vous acceptez d\'être lié par ces Conditions d\'Utilisation. Si vous n\'acceptez pas ces conditions, veuillez ne pas utiliser nos services.',
    termsServicesTitle: '2. Services',
    termsServicesContent: 'Datasignz CreativeMinds fournit des services de production vidéo, post-production, identité à l\'antenne, marketing et marque, et services web. Les conditions spécifiques pour chaque projet seront décrites dans des accords de projet individuels.',
    termsIPTitle: '3. Propriété intellectuelle',
    termsIPContent: 'Tout le contenu de ce site web, y compris le texte, les graphiques, les logos, les images et les logiciels, est la propriété de Datasignz CreativeMinds et est protégé par le droit d\'auteur et d\'autres lois sur la propriété intellectuelle. Vous ne pouvez pas reproduire, distribuer ou créer des œuvres dérivées sans notre permission écrite expresse.',
    termsUserTitle: '4. Responsabilités de l\'utilisateur',
    termsUserIntro: 'Vous acceptez de :',
    termsUser1: 'Fournir des informations exactes lors de l\'utilisation de nos services',
    termsUser2: 'Ne pas utiliser nos services à des fins illégales',
    termsUser3: 'Ne pas interférer avec le bon fonctionnement de notre site web',
    termsUser4: 'Respecter les droits de propriété intellectuelle des autres',
    termsPaymentTitle: '5. Conditions de paiement',
    termsPaymentContent: 'Les conditions de paiement pour les services seront spécifiées dans les accords de projet individuels. Sauf accord contraire, les paiements sont dus dans les 30 jours suivant la date de facturation.',
    termsLiabilityTitle: '6. Limitation de responsabilité',
    termsLiabilityContent: 'Datasignz CreativeMinds ne sera pas responsable des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs découlant de votre utilisation de nos services ou de notre site web.',
    termsTerminationTitle: '7. Résiliation',
    termsTerminationContent: 'Nous nous réservons le droit de résilier ou de suspendre l\'accès à nos services à tout moment, sans préavis, pour un comportement que nous estimons violer ces Conditions d\'Utilisation ou être nuisible aux autres utilisateurs.',
    termsGoverningTitle: '8. Droit applicable',
    termsGoverningContent: 'Ces Conditions d\'Utilisation sont régies et interprétées conformément aux lois du Suriname.',
    termsContactTitle: '9. Contact',
    termsContactContent: 'Pour toute question concernant ces Conditions d\'Utilisation, veuillez nous contacter à brian@datasignz.nl.',
    // Legal Pages - Cookie Policy
    cookieTitle: 'Politique des Cookies',
    cookieWhatTitle: '1. Que sont les cookies',
    cookieWhatContent: 'Les cookies sont de petits fichiers texte qui sont placés sur votre ordinateur ou appareil mobile lorsque vous visitez un site web. Ils sont largement utilisés pour faire fonctionner les sites web plus efficacement et fournir des informations aux propriétaires de sites.',
    cookieHowTitle: '2. Comment nous utilisons les cookies',
    cookieHowIntro: 'Nous utilisons les cookies aux fins suivantes :',
    cookieEssential: 'Cookies Essentiels :',
    cookieEssentialDesc: 'Nécessaires au bon fonctionnement du site web',
    cookieAnalytics: 'Cookies d\'Analyse :',
    cookieAnalyticsDesc: 'Nous aident à comprendre comment les visiteurs interagissent avec notre site',
    cookieFunctional: 'Cookies Fonctionnels :',
    cookieFunctionalDesc: 'Mémorisent vos préférences et paramètres',
    cookieMarketing: 'Cookies Marketing :',
    cookieMarketingDesc: 'Utilisés pour afficher des publicités pertinentes',
    cookieTypesTitle: '3. Types de cookies que nous utilisons',
    cookieEssentialTitle: 'Cookies Essentiels',
    cookieEssentialContent: 'Ces cookies sont nécessaires au fonctionnement du site web et ne peuvent pas être désactivés. Ils sont généralement définis en réponse à des actions que vous effectuez, comme définir vos préférences de confidentialité ou remplir des formulaires.',
    cookieAnalyticsTitle: 'Cookies d\'Analyse',
    cookieAnalyticsContent: 'Nous utilisons des services d\'analyse pour nous aider à comprendre comment notre site web est utilisé. Ces cookies collectent des informations sur votre utilisation du site, comme les pages que vous visitez le plus souvent.',
    cookieThirdPartyTitle: 'Cookies Tiers',
    cookieThirdPartyContent: 'Certains cookies sont placés par des services tiers qui apparaissent sur nos pages, comme des vidéos intégrées de YouTube ou des boutons de partage sur les réseaux sociaux.',
    cookieManagingTitle: '4. Gestion des cookies',
    cookieManagingContent: 'La plupart des navigateurs web vous permettent de contrôler les cookies via leurs paramètres. Vous pouvez configurer votre navigateur pour refuser les cookies ou supprimer certains cookies. Cependant, si vous bloquez ou supprimez les cookies, certaines fonctionnalités de notre site web peuvent ne pas fonctionner correctement.',
    cookieBrowserTitle: '5. Paramètres du navigateur',
    cookieBrowserIntro: 'Vous pouvez gérer les cookies dans les paramètres de votre navigateur :',
    cookieUpdatesTitle: '6. Mises à jour de cette politique',
    cookieUpdatesContent: 'Nous pouvons mettre à jour cette Politique des Cookies de temps en temps. Tout changement sera publié sur cette page avec une date de révision mise à jour.',
    cookieContactTitle: '7. Nous contacter',
    cookieContactContent: 'Si vous avez des questions sur notre utilisation des cookies, veuillez nous contacter à brian@datasignz.nl.',
    // Legal Pages - Disclaimer
    disclaimerTitle: 'Avertissement',
    disclaimerGeneralTitle: '1. Informations générales',
    disclaimerGeneralContent: 'Les informations fournies sur ce site web sont uniquement à des fins d\'information générale. Bien que nous nous efforcions de maintenir les informations à jour et exactes, Datasignz CreativeMinds ne fait aucune déclaration ni garantie d\'aucune sorte, expresse ou implicite, concernant l\'exhaustivité, l\'exactitude, la fiabilité, la pertinence ou la disponibilité du site web ou des informations, produits, services ou graphiques connexes contenus sur le site.',
    disclaimerAdviceTitle: '2. Conseil professionnel',
    disclaimerAdviceContent: 'Le contenu de ce site web n\'est pas destiné à remplacer un conseil professionnel. Consultez toujours des professionnels qualifiés pour toute question concernant des services ou projets spécifiques.',
    disclaimerLinksTitle: '3. Liens externes',
    disclaimerLinksContent: 'Ce site web peut contenir des liens vers des sites web externes qui ne sont pas fournis ou maintenus par Datasignz CreativeMinds. Nous ne garantissons pas l\'exactitude, la pertinence, l\'actualité ou l\'exhaustivité des informations sur ces sites web externes.',
    disclaimerLiabilityTitle: '4. Limitation de responsabilité',
    disclaimerLiabilityContent: 'En aucun cas Datasignz CreativeMinds ne sera responsable de toute perte ou dommage, y compris sans limitation, perte ou dommage indirect ou consécutif, ou toute perte ou dommage découlant de la perte de données ou de profits résultant de ou en relation avec l\'utilisation de ce site web.',
    disclaimerPortfolioTitle: '5. Portfolio et exemples de travail',
    disclaimerPortfolioContent: 'Les éléments du portfolio et les exemples de travail affichés sur ce site web sont uniquement à des fins de démonstration. Les résultats peuvent varier en fonction des exigences, spécifications et circonstances individuelles du projet.',
    disclaimerAvailabilityTitle: '6. Disponibilité',
    disclaimerAvailabilityContent: 'Nous ne garantissons pas que le site web sera disponible à tout moment. Nous pouvons rencontrer des problèmes matériels, logiciels ou autres, ou devoir effectuer une maintenance liée au site web, entraînant des interruptions, des retards ou des erreurs.',
    disclaimerChangesTitle: '7. Modifications',
    disclaimerChangesContent: 'Datasignz CreativeMinds se réserve le droit d\'apporter des modifications à cet avertissement à tout moment. Votre utilisation continue du site web après la publication des modifications constitue votre acceptation de ces modifications.',
    disclaimerContactTitle: '8. Contact',
    disclaimerContactIntro: 'Si vous avez des questions concernant cet Avertissement, veuillez nous contacter à :',
  }
};

const LanguageContext = createContext();

// Supported languages
const SUPPORTED_LANGUAGES = ['en', 'nl', 'es', 'fr'];

// Detect browser language and map to supported languages
const detectBrowserLanguage = () => {
  if (typeof window === 'undefined' || !navigator) return 'en';
  
  // Get browser languages (returns array like ['en-US', 'en', 'nl'])
  const browserLanguages = navigator.languages || [navigator.language || navigator.userLanguage];
  
  for (const lang of browserLanguages) {
    // Extract the base language code (e.g., 'en' from 'en-US')
    const baseLanguage = lang.split('-')[0].toLowerCase();
    
    if (SUPPORTED_LANGUAGES.includes(baseLanguage)) {
      return baseLanguage;
    }
  }
  
  return 'en'; // Default to English
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage for saved language preference
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('preferredLanguage');
      if (saved) {
        return saved;
      }
      // If no saved preference, detect from browser
      const detected = detectBrowserLanguage();
      return detected;
    }
    return 'en';
  });

  // Save language preference to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('preferredLanguage', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || translations['en'][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
